<template>
  <v-container background fluid pa-3>
    <v-btn text color="green" slot="activator" @click="back()" class="btn_show_filter">
      <v-icon :size="16" class="mr-2">fas fa-arrow-left</v-icon>
      <span>{{ $t("back") }}</span>
    </v-btn>
    <v-layout row wrap pa-3 style="background-color: #fff; margin-top: 5px; border-radius: 5px">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn color="primary" v-if="permission_edit == true || admin == 'true'" @click="showPayslip()" :disabled="isCheck">
              <v-icon class="mr-2">far fa-file-alt</v-icon>
              <span>{{ $t("PaySlip") }}</span>
            </v-btn>
            <v-btn color="primary" v-if="permission_edit == true || admin == 'true'" @click="emailPayslip()" :disabled="isCheck">
              <v-icon class="mr-2">fas fa-envelope-open-text</v-icon>
              <span>{{ $t("SendPayslip") }}</span>
            </v-btn>
            <v-btn color="success" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="downloadWHT50()">
              <v-icon class="mr-2">fa-file</v-icon>
              <span>{{ $t("WithholdingTax") }}</span>
            </v-btn>
            <v-btn color="success" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="showcontributions()">
              <v-icon class="mr-2">fa-file</v-icon>
              <span>{{ $t("Contributions") }}</span>
            </v-btn>
            <!-- <v-btn color="warning" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="documentbank()">
              <v-icon class="mr-2" size="16">fa-plus</v-icon>
              <span>แบบฟอร์มเอกสารส่งธนาคาร</span>
            </v-btn>
            <v-btn color="warning" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="documentother()">
              <v-icon class="mr-2" size="16">fa-plus</v-icon>
              <span>รายการจ่ายเงินเดือนอื่นๆ</span>
            </v-btn>-->

            <v-btn color="success" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="downloadexcel()">
              <v-icon class="mr-2">fa-file-excel</v-icon>
              <span>{{ $t("Exportexcel") }}</span>
            </v-btn>

            <v-btn color="primary" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="doCopyTable()">
              <v-icon class="mr-2">fa-clipboard</v-icon>
              <span>{{ $t("CopytoClipboard") }}</span>
            </v-btn>

            <v-btn color="info" class="hidden-xs-only" v-if="showMainTable" @click="showWHT()">
              <v-icon class="mr-2">fa-file</v-icon>
              <span>{{ $t("menu.WithholdingTaxForm") }}</span>
            </v-btn>

            <v-btn color="info" class="hidden-xs-only" v-if="!showMainTable" @click="showWHT()">
              <v-icon class="mr-2">fa-file</v-icon>
              <span>{{ $t("menu.PayrollDetail") }}</span>
            </v-btn>

            <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
              <v-btn slot="activator" v-if="permission_edit == true || admin == 'true'" color="primary" dark fixed bottom right fab @click="buttondocDialog = true">
                <v-icon>apps</v-icon>
              </v-btn>
            </v-flex>
          </v-flex>

          <v-flex md12 sm12 xs12 ma-3>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12 style="margin-top: 10px">
                <v-layout row wrap v-if="!showMainTable">
                  <v-flex xs12 sm6 md3>
                    <v-select :items="branch_items" :item-text="'name'" :item-value="'code'" v-model="selectedBranchShow" label="เลือกสาขา"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-btn color="success" @click="processBranch()">
                      <v-icon class="pr-2" size="16">fa-arrow-right</v-icon>
                      <span>{{ $t("processor") }}</span>
                    </v-btn>
                    <v-btn color="primary" @click="downloadWHT()">
                      <v-icon class="mr-2">fa-file</v-icon>
                      <span>{{ $t("menu.export") }}</span>
                    </v-btn>
                    <v-btn color="primary" v-if="permission_edit == true || admin == 'true'" class="hidden-xs-only" @click="whtForm()">
                      <v-icon class="mr-2">fa-file</v-icon>
                      <span>{{ $t("menu.WithholdingTaxForm") }}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm4 xs12 style="margin-bottom: 10px">
                    <p>{{ $t("doc_no") }} : {{ docno }}</p>
                  </v-flex>
                  <v-flex offset-lg6 offset-md4 offset-sm2 lg2 md4 sm6 xs12 style="margin-bottom: 10px">
                    <v-layout row wrap>
                      <v-flex lg6 md6 sm6 xs6>
                        <p>{{ $t("fromdate") }} : {{ dateformat(showdatestart) }}</p>
                      </v-flex>
                      <v-flex lg6 md6 sm6 xs6>
                        <p>{{ $t("todate") }} : {{ dateformat(showdateend) }}</p>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex v-if="showMainTable" md12 sm12 xs12 class="scroll-able">
                <table id="table_detail" class="table table-bordered coco-sticky-table">
                  <thead>
                    <tr
                      style="
                        background-color: #357ca5;
                        color: white;
                        vertical-align: middle;
                      "
                      v-html="showheadhtml"
                    ></tr>
                  </thead>
                  <tbody v-html="showbodyhtml"></tbody>
                </table>
              </v-flex>
              <v-flex v-if="!showMainTable" md12 sm12 xs12 class="scroll-able">
                <table id="table_detail_2" class="table table-bordered coco-sticky-table">
                  <thead>
                    <tr
                      style="
                        background-color: #357ca5;
                        color: white;
                        vertical-align: middle;
                      "
                    >
                      <td style="text-align:center;font-weight:bold">รหัสพนักงาน</td>
                      <td style="text-align:center;font-weight:bold">ชื่อพนักงาน</td>
                      <td style="text-align:center;font-weight:bold">เงินได้(1)</td>
                      <td style="text-align:center;font-weight:bold">เงินได้(2)</td>
                      <td style="text-align:center;font-weight:bold">รวมเงินได้</td>
                      <td style="text-align:center;font-weight:bold">ภาษี40(1)</td>
                      <td style="text-align:center;font-weight:bold">ภาษี40(2)</td>
                      <td style="text-align:center;font-weight:bold">รวมภาษี</td>
                      <td style="text-align:center;font-weight:bold">รายได้สุธิ</td>
                    </tr>
                  </thead>
                  <tbody v-html="showbodyhtml_branch"></tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :right="'right'" :color="snack_model.type">
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <div class="text-xs-center">
        <v-dialog v-model="dialog_loading" persistent width="260">
          <v-card>
            <v-card-text>
              <br />
              {{ $t(progressbar.msg) + "...." }}
              <v-progress-linear v-model="progressbar.value" :active="progressbar.show" :indeterminate="progressbar.query" :query="progressbar.query"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-layout>
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading_detail" persistent width="350">
        <v-card>
          <v-card-text>
            Processing... <span v-if="progress > 0">{{ progress }}%</span>
            <v-progress-linear :value="progress" max="100" v-if="progress > 0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading_WHT" persistent width="450">
        <v-card>
          <v-card-title>
            <span class="headline">PDF Generation</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog_loading_WHT = false" style="color:#000">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex xs12 v-if="zipLinks.length === 0">
                <p>Generate PDF...</p>
              </v-flex>
              <v-flex xs12 v-if="zipLinks.length > 0">
                <h3>Download ZIP Files:</h3>
                <v-label style="color:red">Complete {{ zipLinks.length }}/{{ zipChunks.length }}</v-label>
                <v-progress-linear :value="(zipLinks.length / zipChunks.length) * 100" max="100" v-if="zipLinks.length > 0"></v-progress-linear>
                <ul>
                  <li v-for="(link, index) in zipLinks" :key="index">
                    <a :href="link.href" :download="link.download">{{ link.text }}</a>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-layout row justify-center>
      <v-dialog v-model="buttondocDialog" persistent max-width="550px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md3 xs12 px-1>
                  <v-btn block color="success" @click="showcontributions()">
                    <v-icon class="mr-2" size="16">fa-plus</v-icon>
                    <span>{{ $t("Contributions") }}</span>
                  </v-btn>
                </v-flex>
                <v-flex md3 xs12 px-1>
                  <v-btn block color="warning" @click="documentbank()">
                    <v-icon class="mr-2" size="16">fa-plus</v-icon>
                    <span>แบบฟอร์มเอกสารส่งธนาคาร</span>
                  </v-btn>
                </v-flex>
                <v-flex md3 xs12 px-1>
                  <v-btn block color="warning" @click="documentother()">
                    <v-icon class="mr-2" size="16">fa-plus</v-icon>
                    <span>รายการจ่ายเงินเดือนอื่นๆ</span>
                  </v-btn>
                </v-flex>
                <v-flex md3 xs12 px-1>
                  <v-btn block color="primary" @click="showWHT()">
                    <v-icon class="mr-2" size="16">fa-plus</v-icon>
                    <span>{{ $t("menu.WithholdingTaxForm") }}</span>
                  </v-btn>
                </v-flex>
                <v-flex md3 xs12 px-1>
                  <v-btn block color="success" @click="downloadexcel()">
                    <v-icon class="mr-2" size="16">fa-file-excel</v-icon>
                    <span>{{ $t("Exportexcel") }}</span>
                  </v-btn>
                </v-flex>
                <v-flex md3 xs12 px-1>
                  <v-btn block color="primary" @click="doCopyTable()">
                    <v-icon class="mr-2" size="16">fa-clipboard</v-icon>
                    <span>{{ $t("CopytoClipboard") }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="buttondocDialog = false">ยกเลิก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialog_contribution" persistent max-width="550px">
        <v-card>
          <v-card-title>
            <span class="headline">เอกสารนำส่งเงินสมทบ</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select :items="branch_contributors" :item-text="'name'" :item-value="'code'" v-model="select_branch_contributors" label="เลือกสาขา"></v-select>
                </v-flex>
                <v-flex xs12>
                  <!-- <v-btn color="success" @click="processContribute()">
                    <v-icon class="pr-2" size="16">fa-play</v-icon>
                    <span>{{ $t("processor") }}</span>
                  </v-btn> -->
                  <v-btn color="success" @click="downloadContribution()">
                    <v-icon class="" size="16">fa-file-excel</v-icon>
                    <span> {{ $t("Exportexcel") }}</span>
                  </v-btn>
                  <v-btn color="success" @click="downloadContributionTxt()">
                    <v-icon class="" size="16">fa-file</v-icon>
                    <span> {{ $t("Exporttxtfile") }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <table id="table_detail_contributor" class="table table-bordered" style="display:none">
                <thead>
                  <tr>
                    <th>
                      เลขที่บัตรประชาชน
                    </th>
                    <th>
                      คำนำหน้า
                    </th>
                    <th>
                      ชื่อ
                    </th>
                    <th>
                      สกุล
                    </th>
                    <th>
                      ค่าจ้าง
                    </th>
                    <th>
                      เงินสมทบ
                    </th>
                  </tr>
                </thead>
                <tbody v-html="showContributorsDetail"></tbody>
              </table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog_contribution = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Form Create Doc -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog_create" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">เลือกประเภทการจ่ายเงิน</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('date')" type="date" v-model="form_dialog_create.date" required hide-details />
                  </v-flex>
                  <!-- <v-flex xs12 sm6 md6>
                    <v-select
                      :items="typepayment"
                      v-model="checktypepayment"
                      label="เลือกประเภทการจ่ายเงิน"
                    ></v-select>
                  </v-flex> -->
                  <v-flex xs12 sm6 md6>
                    <v-select :items="['TTB', 'กรุงไทย']" v-model="checktypepayment" label="เลือกธนาคาร"></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="เลขที่บัญชีบริษัท" type="number" v-model="company_account" required hide-details />
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="ชื่อบัญชีบริษัท" type="text" v-model="company_account_name" required hide-details />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog_create = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="downloadexcelbank()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_create_other" persistent max-width="400px">
          <v-card>
            <v-card-title>
              <span class="headline">เลือกประเภทการจ่ายเงิน</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select :items="['พร้อมเพย์', 'เงินสด', 'อื่นๆ']" v-model="checktypepaymentother" label="เลือกประเภทการจ่ายเงิน"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog_create_other = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="downloadexcelbankother()">download</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import PayrollService from "@/services/PayrollService";
import SettingService from "@/services/SettingService";
import DocumentService from "@/services/DocumentService";
import UserService from "@/services/UserService";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import pdf from "vue-pdf";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import moment from "moment";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import $ from "jquery";
import Utils from "@/utils/";
import JSZip from "jszip";
export default {
  components: {
    pdf,
  },
  mounted() {
    this.setToolbar({
      pageTitle: "EmployeeCreate",
      patternTool: "2",
    });
    $("#table_detail").delegate("#select_all", "change", function() {
      var status = this.checked;
      var count = 0;
      $(".checkit").each(function() {
        this.checked = status;
        count += 1;
      });
      v.checkedValue = count;
      if (!status) {
        v.checkedValue = 0;
      }
      if (v.checkedValue > 0) {
        v.isCheck = false;
      } else {
        v.isCheck = true;
      }
    });
    var v = this;
    $("#table_detail").delegate(".checkit", "change", function() {
      var status = this.checked;
      if (status) {
        v.checkedValue += 1;
      } else {
        v.checkedValue -= 1;
        if (v.checkedValue < 0) {
          v.checkedValue = 0;
        }
      }
      console.log(status);
      console.log("checkedValue: ", v.checkedValue);
      if (v.checkedValue > 0) {
        v.isCheck = false;
      } else {
        v.isCheck = true;
      }
    });
  },

  created: async function() {
    this.docno = this.$route.params.docno;
    this.details_count = this.$route.params.details;
    this.admin = localStorage._is_admin;
    await this.getdataCompany();
    await this.getGeneralSetting();
    await this.getProfileBranchList();
    await this.ListDetailByDocNo(this.$route.params.docno, this.details_count);
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("PayRollDocumentList");
  },
  data: () => ({
    zipLinks: [],
    zipLink: null,
    linkContainer: [],
    dialog_loading_WHT: false,
    typepayment: [],
    branch_detail: [],
    head_exampleformbank: ["ลำดับ", "ชื่อธนาคาร", "ชื่อบัญชี(35 ตัวอักษร)", "เลขที่บัญชี", "จำนวนเงิน"],
    index: 1,
    checktypepayment: "",
    checktypepaymentother: "",
    selectedBranchShow: "",
    branch_list: [{ code: "", name: "ทั้งหมด" }],
    dialog_create: false,
    details_count: 0,
    person1: 0,
    person2: 0,
    totalEarning1: 0,
    totalEarning2: 0,
    totalDeductTax1: 0,
    totalDeductTax2: 0,
    data_details: [],
    dialog_contribution: false,
    admin: false,
    buttondocDialog: false,
    emp_code: "",
    dialog_create_other: false,
    dialog_loading: false,
    dialog_loading_detail: false,
    progress: 0,
    load_msg: "Loaddata",
    send_msg: "Sending",
    progressbar: {
      value: 0,
      query: false,
      show: false,
      msg: "",
    },
    send_email: [],
    emp_select: [],
    email_payslip: {
      doc: "",
      src: "",
      ltdName: " ",
      empcode: "",
      email: "",
      jsonData: [],
      income: "",
      incomeAmount: "",
      expenses: "",
      expensesAmount: "",
      space: "",
      spaceexpenses: "",
      spaceincome: "",
      data: null,
      pdfDocGen: null,
      header_table: [
        {
          text: "#",
        },
        {
          text: "รายการ",
        },
        {
          text: "หน่วยนับ",
        },
        {
          text: "จำนวน",
        },
      ],
    },
    isCheck: true,
    checkedValue: 0,
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    acc_no: "",
    company_account: "4972462099",
    company_account_name: "บจก. เอสเอ็มแอล ซอฟต์",
    payroll_doc: {
      doc_no: "",
      begin_date: "",
      end_date: "",
      remark: "",
      creator_code: localStorage._usercode,
    },
    totalChunksSize: 0,
    selectedWHT: "",
    snackbarcolor: "red",
    docDialog: false,
    filterDialog: false,
    table_data: [],
    table_head_model: {
      ชื่อ: "1",
      ประเภท: "0",
      ตำแหน่ง: "0",
      วันทำงานเดือนนี้: "0",
      เงินเดือน: "1",
      ค่าฝีมือ: "0",
      ค่าตำแหน่ง: "0",
      รวมเงินได้: "0",
      วันละ: "0",
      ชั่วโมงละ: "0",
      ชม_OT_รวม: "0",
      เงิน_OT_รวม: "0",
      รายละเอียดรายรับ: "1",
      รวมรายรับอื่นๆ: "1",
      เบี้ยขยัน: "0",
      วันหยุดพิเศษ: "0",
      รายได้วันหยุดพิเศษ: "0",
      รวมรายได้: "1",
      ชม_ลา_รวม: "0",
      หักเงินลา_รวม: "0",
      ลาไม่หักเงิน: "0",
      ชม_ขาด_รวม: "0",
      หักเงินขาด_รวม: "0",
      สาย_รวม: "0",
      หักเงินสาย_รวม: "0",
      ออกก่อน_รวม: "0",
      หักออกก่อน_รวม: "0",
      ประกันสังคม: "1",
      ภาษี: "1",
      รายละเอียดรายจ่าย: "1",
      รวมรายจ่ายอื่นๆ: "1",
      รวมหัก: "1",
      คงเหลือเงิน: "1",
      ประเภทการจ่ายเงิน: "1",
      เลขที่บัญชี: "1",
      เวลาเข้างาน: "0",
    },
    table_head_count: 1,
    pageActive: 1,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: "",
    },
    ss_rate: 0,
    zipChunks: [],
    errmsg: "",
    result_data: [],
    branch_items: [],
    data_by_branch: [],
    data_by_all_branch: [],
    branch_contributors: [],
    select_branch_contributors: "",
    select_branch_pay: "",
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    responvalue: "",
    showbodyhtml: "",
    showbodyhtml_branch: "",
    showheadhtml: "",
    bodyHtml: "",
    footerHtml: "",
    workhour_rate: [],
    ot_rate: [],
    absent_rate: [],
    leave_rate: [],
    ob_rate: [],
    ot_value: [],
    otobj: [],
    headReceive: [],
    headVat: [],
    headExpenses: [],
    earningDetailName: "",
    responvalue: [],
    late_rate: [],
    selected: [],
    selectAll: false,
    data: [],
    showdatestart: "",
    showdateend: "",
    permission_edit: false,
    permission_view: false,
    empCode: localStorage._empcode,
    permission: [],
    listpaymenttype: [],
    detail_example: [],
    showContributorsDetail: "",
    showMainTable: true,
    form_dialog_create: {
      date: "",
    },
  }),
  methods: {
    ...mapActions("toolbar", ["setToolbar"]),
    ...mapState("permissionmenu", ["permission_List"]),
    goto(path) {
      this.$router.push("/" + path);
    },

    async getdataCompany() {
      const tmpResult = await SettingService.getDataCompany();
      this.companyName = tmpResult.data.content[0].companyname;
      this.companybuilding = tmpResult.data.content[0].building; //อาคาร
      this.companyroom_no = tmpResult.data.content[0].room_no; //ห้อง
      this.companyfloor = tmpResult.data.content[0].floor; //ชั้น
      this.companyvillage = tmpResult.data.content[0].village; //หมู่บ้าน
      this.companyhouse_no = tmpResult.data.content[0].house_no; //บ้านเลขที่
      this.companyvillage_no = tmpResult.data.content[0].village_no; //หมู่ที่
      this.companyalley_lane = tmpResult.data.content[0].alley_lane; //ตรอก/ซอย
      this.companyroad = tmpResult.data.content[0].road; //ถนน
      this.companysubdistrict_subarea = tmpResult.data.content[0].subdistrict_subarea; //ตำบล/แขวง
      this.companydistrict_area = tmpResult.data.content[0].district_area; //อำเภอ/เขต
      this.companyprovince = tmpResult.data.content[0].province; //จังหวัด
      this.companypostcode = tmpResult.data.content[0].postcode; //รหัสไปรษณีย์
      this.taxpayer_number = tmpResult.data.content[0].taxpayer_number;
      this.acc_no = tmpResult.data.content[0].acc_no;
    },
    getGeneralSetting() {
      SettingService.getGeneralSetting()
        .then((res) => {
          console.log("getGeneralSetting", res);
          if (res.data.content.length > 0) {
            this.ss_rate = res.data.content[0].ss_rate;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .then(() => {});
    },
    async processBranch() {
      this.selectedWHT = this.selectedBranchShow;
      let v = this;
      this.showbodyhtml_branch = "";

      console.log(this.data_by_branch);
      this.table_show_details = [];

      if (this.selectedBranchShow != "") {
        this.person1 = 0;
        this.person2 = 0;
        this.totalEarning1 = 0;
        this.totalEarning2 = 0;
        this.totalDeductTax1 = 0;
        this.totalDeductTax2 = 0;

        this.data_by_branch
          .filter((branch) => branch.branch_code == this.selectedBranchShow)
          .forEach((element) => {
            element.details.forEach((item) => {
              v.table_show_details.push({
                emp_code: item.emp_code,
                emp_name: item.emp_name,
                prefix: item.prefix,
                firstName: item.firstName,
                lastName: item.lastName,
                idcard: item.idcard,
                total_income1: item.total_income1,
                total_income2: item.total_income2,
                total_income: item.total_income,
                total_tax1: item.total_tax1,
                total_tax2: item.total_tax2,
                total_tax: item.total_tax,
                total_balance: item.total_balance,
              });
            });
          });
      } else {
        this.person1 = 0;
        this.person2 = 0;
        this.totalEarning1 = 0;
        this.totalEarning2 = 0;
        this.totalDeductTax1 = 0;
        this.totalDeductTax2 = 0;
        const allDetails = this.data_by_branch.flatMap((branch) => branch.details);

        // Group by emp_code and sum up the relevant fields
        const consolidated = allDetails.reduce((acc, curr) => {
          if (!acc[curr.emp_code]) {
            acc[curr.emp_code] = { ...curr };
          } else {
            acc[curr.emp_code].total_income1 += curr.total_income1;
            acc[curr.emp_code].total_income2 += curr.total_income2;
            acc[curr.emp_code].total_income += curr.total_income;
            acc[curr.emp_code].total_tax += curr.total_tax;
            acc[curr.emp_code].total_tax1 += curr.total_tax1;
            acc[curr.emp_code].total_tax2 += curr.total_tax2;
            acc[curr.emp_code].total_balance += curr.total_balance;
            acc[curr.emp_code].emp_name = curr.emp_name;
            acc[curr.emp_code].prefix = curr.prefix;
            acc[curr.emp_code].firstName = curr.firstName;
            acc[curr.emp_code].lastName = curr.lastName;
          }
          return acc;
        }, {});

        // Convert the object back to an array
        const finalArray = Object.values(consolidated);

        v.table_show_details = finalArray;
        if (v.data_by_all_branch.length == 0) {
          v.data_by_all_branch = finalArray;
          v.data_by_all_branch.sort((a, b) => a.emp_code.localeCompare(b.emp_code));
        }
      }
      this.table_show_details.sort((a, b) => a.emp_code.localeCompare(b.emp_code));

      let FooterSumTotalIncome = 0;
      let FooterSumTotalIncome1 = 0;
      let FooterSumTotalIncome2 = 0;
      let FooterSumTotalTax = 0;
      let FooterSumTotalTax1 = 0;
      let FooterSumTotalTax2 = 0;
      let FooterSumTotalBalance = 0;

      console.log(this.table_show_details);

      this.table_show_details.forEach((element) => {
        if (element.total_balance != 0) {
          let row = `<tr>
                      <td>${element.emp_code}</td>
                      <td>${element.emp_name}</td>
                      <td style='text-align:right;background-color:#D1C4E9'>${v.thousandSep(element.total_income1)}</td>
                      <td style='text-align:right;background-color:#D1C4E9'>${v.thousandSep(element.total_income2)}</td>
                      <td style='text-align:right;background-color:#D1C4E9'>${v.thousandSep(element.total_income)}</td>
                      <td style="text-align:right;background-color: #FFCCBC">${v.thousandSep(element.total_tax1)}</td>
                      <td style="text-align:right;background-color: #FFCCBC">${v.thousandSep(element.total_tax2)}</td>
                      <td style="text-align:right;background-color: #FFCCBC">${v.thousandSep(element.total_tax)}</td>
                      <td style="text-align:right;background-color: #B2FF59">${v.thousandSep(element.total_balance)}</td>`;

          this.showbodyhtml_branch += row;
          FooterSumTotalIncome += element.total_income;
          FooterSumTotalIncome1 += element.total_income1;
          FooterSumTotalIncome2 += element.total_income2;
          FooterSumTotalTax1 += element.total_tax1;
          FooterSumTotalTax2 += element.total_tax2;
          FooterSumTotalTax += element.total_tax;
          FooterSumTotalBalance += element.total_balance;
          if (element.total_income1 > 0) {
            this.person1 += 1;
          }
          if (element.total_income2 > 0) {
            this.person2 += 1;
          }
        }
      });

      this.totalEarning1 = FooterSumTotalIncome1;
      this.totalEarning2 = FooterSumTotalIncome2;
      this.totalDeductTax1 = FooterSumTotalTax1;
      this.totalDeductTax2 = FooterSumTotalTax2;

      let footer = `<tr>
          <td colspan="2" style="text-align: right;font-weight:bold;">รวม</td>
          <td style='text-align:right;background-color:#D1C4E9;font-weight:bold;'>${v.thousandSep(FooterSumTotalIncome1)}</td>
          <td style='text-align:right;background-color:#D1C4E9;font-weight:bold;'>${v.thousandSep(FooterSumTotalIncome2)}</td>
          <td style='text-align:right;background-color:#D1C4E9;font-weight:bold;'>${v.thousandSep(FooterSumTotalIncome)}</td>
          <td style="text-align:right;background-color: #FFCCBC;font-weight:bold;">${v.thousandSep(FooterSumTotalTax1)}</td>
          <td style="text-align:right;background-color: #FFCCBC;font-weight:bold;">${v.thousandSep(FooterSumTotalTax2)}</td>
          <td style="text-align:right;background-color: #FFCCBC;font-weight:bold;">${v.thousandSep(FooterSumTotalTax)}</td>
          <td style="text-align:right;background-color: #B2FF59;font-weight:bold;">${v.thousandSep(FooterSumTotalBalance)}</td>
        </tr>`;
      this.showbodyhtml_branch += footer;

      if (this.selectedBranchShow == "") {
        // this.tmpResult = await SettingService.getDataCompany();
        // console.log(this.tmpResult);
        // v.companyName = this.tmpResult.data.content[0].companyname;
        // v.companybuilding = this.tmpResult.data.content[0].building; //อาคาร
        // v.companyroom_no = this.tmpResult.data.content[0].room_no; //ห้อง
        // v.companyfloor = this.tmpResult.data.content[0].floor; //ชั้น
        // v.companyvillage = this.tmpResult.data.content[0].village; //หมู่บ้าน
        // v.companyhouse_no = this.tmpResult.data.content[0].house_no; //บ้านเลขที่
        // v.companyvillage_no = this.tmpResult.data.content[0].village_no; //หมู่ที่
        // v.companyalley_lane = this.tmpResult.data.content[0].alley_lane; //ตรอก/ซอย
        // v.companyroad = this.tmpResult.data.content[0].road; //ถนน
        // v.companysubdistrict_subarea = this.tmpResult.data.content[0].subdistrict_subarea; //ตำบล/แขวง
        // v.companydistrict_area = this.tmpResult.data.content[0].district_area; //อำเภอ/เขต
        // v.companyprovince = this.tmpResult.data.content[0].province; //จังหวัด
        // v.companypostcode = this.tmpResult.data.content[0].postcode; //รหัสไปรษณีย์
        // v.taxpayer_number = this.tmpResult.data.content[0].taxpayer_number;
      } else {
        this.tmpResult = await SettingService.getBranchByCode(this.selectedBranchShow);
        console.log(this.tmpResult);
        v.companyName = this.tmpResult.data.companyname;
        v.companybuilding = this.tmpResult.data.building; //อาคาร
        v.companyroom_no = this.tmpResult.data.room_no; //ห้อง
        v.companyfloor = this.tmpResult.data.floor; //ชั้น
        v.companyvillage = this.tmpResult.data.village; //หมู่บ้าน
        v.companyhouse_no = this.tmpResult.data.house_no; //บ้านเลขที่
        v.companyvillage_no = this.tmpResult.data.village_no; //หมู่ที่
        v.companyalley_lane = this.tmpResult.data.alley_lane; //ตรอก/ซอย
        v.companyroad = this.tmpResult.data.road; //ถนน
        v.companysubdistrict_subarea = this.tmpResult.data.subdistrict_subarea; //ตำบล/แขวง
        v.companydistrict_area = this.tmpResult.data.district_area; //อำเภอ/เขต
        v.companyprovince = this.tmpResult.data.province; //จังหวัด
        v.companypostcode = this.tmpResult.data.postcode; //รหัสไปรษณีย์
        v.taxpayer_number = this.tmpResult.data.taxpayer_number;
      }
    },

    downloadWHT50() {
      console.log("this.data_by_all_branch : ", this.data_by_all_branch);
      var v = this;
      var jsonperson = [];
      this.zipLink = null;
      this.linkContainer = [];
      v.totalChunksSize = 0;
      this.dialog_loading_WHT = true;

      var checkedValues = $('input[class="checkit"]:checked')
        .map(function() {
          return this.value;
        })
        .get();
      if (checkedValues != "") {
        let arr = [];
        checkedValues.forEach((element) => {
          arr.push(element);
        });
        this.emp_select = arr;

        console.log(this.emp_select);

        this.emp_select.forEach((empSelect) => {
          this.data_by_all_branch.forEach((element) => {
            if (empSelect == element.emp_code) {
              var empfilter = v.data.filter((obj) => obj.code == element.emp_code);

              if (empfilter.length > 0 && element.total_balance > 0) {
                jsonperson.push({
                  emp_code: element.emp_code,
                  id_card: empfilter.length > 0 ? empfilter[0].idCard : "",
                  emp_name: element.emp_name,
                  payDate: empfilter.length > 0 ? empfilter[0].toDate : "",
                  address: empfilter.length > 0 ? empfilter[0].address : "",
                  social_pay: empfilter.length > 0 ? empfilter[0].deductSS : "",
                  tax_number: empfilter.length > 0 ? empfilter[0].taxNumber : "",
                  earning: element.total_income,
                  tax_pay: element.total_tax,
                  total_income1: element.total_income1,
                  total_income2: element.total_income2,
                  total_tax1: element.total_tax1,
                  total_tax2: element.total_tax2,
                  total_balance: element.total_balance,
                });
                jsonperson.push({
                  emp_code: element.emp_code,
                  id_card: empfilter.length > 0 ? empfilter[0].idCard : "",
                  emp_name: element.emp_name,
                  payDate: empfilter.length > 0 ? empfilter[0].toDate : "",
                  address: empfilter.length > 0 ? empfilter[0].address : "",
                  social_pay: empfilter.length > 0 ? empfilter[0].deductSS : "",
                  tax_number: empfilter.length > 0 ? empfilter[0].taxNumber : "",
                  earning: element.total_income,
                  tax_pay: element.total_tax,
                  total_income1: element.total_income1,
                  total_income2: element.total_income2,
                  total_tax1: element.total_tax1,
                  total_tax2: element.total_tax2,
                  total_balance: element.total_balance,
                });
              }
            }
          });
        });

        this.pdf50(jsonperson);
      } else {
        this.snack_model.msg = "กรุณาเลือกพนักงาน";
        this.snack_model.type = "error";
        this.snack_model.status = true;
        this.dialog_loading_WHT = false;
      }
    },
    chunkArray(array, chunkSize) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    },
    async pdf50(jsonperson) {
      console.log(jsonperson);
      jsonperson.sort((a, b) => a.tax_number.localeCompare(b.tax_number));

      const url = "/static/pdf/approve_wh3_081156.pdf";
      const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
      const urlfont = "/static/THSarabunBold.ttf";
      const fontBytes = await fetch(urlfont).then((res) => res.arrayBuffer());

      let v = this;

      // await this.newjson.details.forEach(async (element, index) => {

      // console.log(jsonperson.length);
      const chunkSize = 2;
      const chunks = this.chunkArray(jsonperson, chunkSize);
      const zipChunkSize = 500 / chunkSize; // Number of chunks per ZIP file
      this.zipChunks = this.chunkArray(chunks, zipChunkSize);

      for (let i = 0; i < v.zipChunks.length; i++) {
        const zip = new JSZip();
        const zipChunk = v.zipChunks[i];

        for (let j = 0; j < zipChunk.length; j++) {
          const chunk = zipChunk[j];
          await this.downloadChunk(chunk, i * zipChunkSize + j, chunks.length - 1, existingPdfBytes, fontBytes, zip);
        }

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const zipFileName = `${v.data[0].toDate}pdf_files_part_${i + 1}.zip`;
        this.zipLinks.push(this.createDownloadLink(zipBlob, zipFileName));
      }
    },
    async downloadChunk(chunk, idx, chunksSize, existingPdfBytes, fontBytes, zip) {
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const srcDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      pdfDoc.registerFontkit(fontkit);

      let v = this;

      const customFont = await pdfDoc.embedFont(fontBytes);

      let i = 0;
      let k = 0;

      for (var x = 1; x < chunk.length; x++) {
        //  console.log("111");
        var [copyPage] = await v.getCopyDoc(pdfDoc, PDFDocument, existingPdfBytes, srcDoc);

        pdfDoc.addPage(copyPage);
        //  console.log("222");
      }

      var pages = pdfDoc.getPages();

      await chunk.forEach(async (element, index) => {
        var firstPage = pages[index];
        // console.log("index: ", index);
        // console.log(firstPage);
        var { width, height } = firstPage.getSize();
        let tax_pay = 0;
        // เล่มที่
        // firstPage.drawText("001", {
        //   x: 530,
        //   y: 783 ,
        //   size: 11,
        //   font: customFont,
        //   color: rgb(0, 0, 0),
        // });
        //เลขที่

        firstPage.drawText(element.tax_number, {
          x: 515,
          y: 768,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //เลขประจำตัวผู้เสียภาษีอาการ(13 หลัก)
        if (this.taxpayer_number != null) {
          firstPage.drawText("" + this.taxpayer_number.substring(0, 1), {
            x: 378,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(1, 2), {
            x: 396,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(2, 3), {
            x: 408,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(3, 4), {
            x: 420,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(4, 5), {
            x: 432,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(5, 6), {
            x: 451,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(6, 7), {
            x: 462,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(7, 8), {
            x: 474,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(8, 9), {
            x: 486,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(9, 10), {
            x: 498,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(10, 11), {
            x: 517,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(11, 12), {
            x: 529,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + this.taxpayer_number.substring(12, 13), {
            x: 548,
            y: 748,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
        //ชื่อบริษัท
        firstPage.drawText("" + this.companyName, {
          x: 60,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        //เลขประจำตัวผู้เสียภาษีอาการ

        firstPage.drawText("0", {
          x: 422,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("1", {
          x: 440,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("2", {
          x: 452,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("3", {
          x: 464,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("4", {
          x: 476,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("5", {
          x: 494,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("6", {
          x: 506,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("7", {
          x: 518,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("8", {
          x: 530,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("9", {
          x: 548,
          y: 732,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //ที่อยู่
        firstPage.drawText(
          "" +
            this.companyhouse_no +
            " ตำบล " +
            this.companysubdistrict_subarea +
            "    อำเภอ " +
            this.companydistrict_area +
            "    จังหวัด " +
            this.companyprovince +
            "    " +
            this.companypostcode,
          { x: 60, y: 708, size: 11, font: customFont, color: rgb(0, 0, 0) }
        );

        //เลขประจำตัวผู้เสียภาษีอาการ(ผู้ถูกหัก13 หลัก)
        let id_card = element.id_card;
        let earning = 0;
        if (id_card != null) {
          firstPage.drawText("" + id_card.substring(0, 1), {
            x: 379,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(1, 2), {
            x: 397,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(2, 3), {
            x: 408,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(3, 4), {
            x: 420,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(4, 5), {
            x: 432,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(5, 6), {
            x: 451,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(6, 7), {
            x: 463,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(7, 8), {
            x: 475,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(8, 9), {
            x: 487,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(9, 10), {
            x: 499,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(10, 11), {
            x: 517,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(11, 12), {
            x: 529,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          firstPage.drawText("" + id_card.substring(12, 13), {
            x: 548,
            y: 679,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
        // เลขประจำตัวผู้เสียภาษีอาการ(ผู้ถูกหัก)

        firstPage.drawText("", {
          x: 423,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 441,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 452,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 463,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 476,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 495,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 507,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 519,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 530,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 549,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //ชื่อ-นามสกุล
        firstPage.drawText("" + element.emp_name, {
          x: 60,
          y: 660,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        //ที่อยู่
        firstPage.drawText("" + element.address, {
          x: 60,
          y: 633,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        //ลำดับที่
        firstPage.drawText("", {
          x: 100,
          y: 605,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        //เลือกเอกสาร
        firstPage.drawText("", {
          x: 212,
          y: 605,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        //ประเภทเงินได้เงินเดือน(วัน)
        let date = moment(element.payDate).format("DD/MM/YYYY");
        if (element.total_income1 > 0) {
          firstPage.drawText("" + date, {
            x: 350,
            y: 535,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          // เงินเดือน
          earning = this.thousandSep(element.total_income1).split(".");
          if (earning[0].length >= 13) {
            firstPage.drawText("" + earning[0], {
              x: 440 - 5 * (earning[0].length - 4) - earning[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (earning[0].length < 13 && earning[0].length >= 9) {
            firstPage.drawText("" + earning[0], {
              x: 440 - 5 * (earning[0].length - 3) - earning[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (earning[0].length < 9 && earning[0].length >= 4) {
            firstPage.drawText("" + earning[0], {
              x: 470 - 5 * (earning[0].length - 2) - earning[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else {
            firstPage.drawText("" + earning[0], {
              x: 440 - 5 * (earning[0].length - 1) - earning[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          }

          firstPage.drawText("." + earning[1], {
            x: 474,
            y: 535,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          // ภาษี
          tax_pay = this.thousandSep(element.total_tax1).split(".");
          if (tax_pay[0].length >= 13) {
            firstPage.drawText("" + tax_pay[0], {
              x: 515 - 5 * (tax_pay[0].length - 4) - tax_pay[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (tax_pay[0].length < 13 && tax_pay[0].length >= 9) {
            firstPage.drawText("" + tax_pay[0], {
              x: 515 - 5 * (tax_pay[0].length - 3) - tax_pay[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (tax_pay[0].length < 9 && tax_pay[0].length >= 4) {
            firstPage.drawText("" + tax_pay[0], {
              x: 540 - 5 * (tax_pay[0].length - 2) - tax_pay[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else {
            firstPage.drawText("" + tax_pay[0], {
              x: 540 - 5 * (tax_pay[0].length - 1) - tax_pay[0].length,
              y: 535,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          }

          firstPage.drawText("." + tax_pay[1], {
            x: 545,
            y: 535,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
        if (element.total_income2 > 0) {
          firstPage.drawText("" + date, {
            x: 350,
            y: 520,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
          // เงินเดือน
          earning = this.thousandSep(element.total_income2).split(".");
          if (earning[0].length >= 13) {
            firstPage.drawText("" + earning[0], {
              x: 440 - 5 * (earning[0].length - 4) - earning[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (earning[0].length < 13 && earning[0].length >= 9) {
            firstPage.drawText("" + earning[0], {
              x: 440 - 5 * (earning[0].length - 3) - earning[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (earning[0].length < 9 && earning[0].length >= 4) {
            firstPage.drawText("" + earning[0], {
              x: 470 - 5 * (earning[0].length - 2) - earning[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else {
            firstPage.drawText("" + earning[0], {
              x: 440 - 5 * (earning[0].length - 1) - earning[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          }

          firstPage.drawText("." + earning[1], {
            x: 474,
            y: 520,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });

          // ภาษี
          tax_pay = this.thousandSep(element.total_tax2).split(".");
          if (tax_pay[0].length >= 13) {
            firstPage.drawText("1" + tax_pay[0], {
              x: 515 - 5 * (tax_pay[0].length - 4) - tax_pay[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (tax_pay[0].length < 13 && tax_pay[0].length >= 9) {
            firstPage.drawText("2" + tax_pay[0], {
              x: 515 - 5 * (tax_pay[0].length - 3) - tax_pay[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else if (tax_pay[0].length < 9 && tax_pay[0].length >= 4) {
            firstPage.drawText("" + tax_pay[0], {
              x: 540 - 5 * (tax_pay[0].length - 2) - tax_pay[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          } else {
            firstPage.drawText("" + tax_pay[0], {
              x: 540 - 5 * (tax_pay[0].length - 1) - tax_pay[0].length,
              y: 520,
              size: 11,
              font: customFont,
              color: rgb(0, 0, 0),
            });
          }

          firstPage.drawText("." + tax_pay[1], {
            x: 545,
            y: 520,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
        //ประเภทเงินได้ค่าธรรมเนียม(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 520,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //ประเภทเงินได้ค่าลิขสิทธิ์(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 506,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 506,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 506,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 506,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 506,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //ประเภทเงินได้ดอกเบี้ย(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 492,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 492,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 492,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 492,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 492,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //4.1(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 435,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 435,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 435,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 435,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 435,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //4.1.1(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 420,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 420,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 420,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 420,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 420,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //4.1.2(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 405,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 405,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 405,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 405,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 405,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        //4.1.3(วัน)
        firstPage.drawText("", {
          x: 360,
          y: 390,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 390,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 390,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 390,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 390,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        firstPage.drawText("", {
          x: 360,
          y: 362,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 444,
          y: 362,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 362,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 515,
          y: 362,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 362,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        firstPage.drawText("", {
          x: 360,
          y: 332,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 439,
          y: 332,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 332,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 510,
          y: 332,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 332,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        firstPage.drawText("", {
          x: 360,
          y: 304,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 439,
          y: 304,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 304,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 510,
          y: 304,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 304,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        firstPage.drawText("", {
          x: 360,
          y: 275,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 439,
          y: 275,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 275,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 510,
          y: 275,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 275,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        firstPage.drawText("", {
          x: 360,
          y: 217,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 439,
          y: 217,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 217,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 510,
          y: 217,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 217,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        firstPage.drawText("", {
          x: 360,
          y: 202,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 439,
          y: 202,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 474,
          y: 202,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 510,
          y: 202,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("", {
          x: 545,
          y: 202,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        // เงินเดือนรวม
        let sumearning = this.thousandSep(element.earning).split(".");
        if (sumearning[0].length >= 13) {
          firstPage.drawText("1" + sumearning[0], {
            x: 431 - 5 * (sumearning[0].length - 4) - sumearning[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        } else if (sumearning[0].length < 13 && sumearning[0].length >= 9) {
          firstPage.drawText("2" + sumearning[0], {
            x: 431 - 5 * (sumearning[0].length - 3) - sumearning[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        } else if (sumearning[0].length < 9 && sumearning[0].length >= 4) {
          firstPage.drawText("" + sumearning[0], {
            x: 470 - 5 * (sumearning[0].length - 2) - sumearning[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        } else {
          firstPage.drawText("4" + sumearning[0], {
            x: 431 - 5 * (sumearning[0].length - 1) - sumearning[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }

        firstPage.drawText("." + sumearning[1], {
          x: 474,
          y: 181,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });

        // ภาษีรวม
        let sumtax_pay = this.thousandSep(element.tax_pay).split(".");
        if (sumtax_pay[0].length >= 13) {
          firstPage.drawText("1" + sumtax_pay[0], {
            x: 502 - 5 * (sumtax_pay[0].length - 4) - sumtax_pay[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        } else if (sumtax_pay[0].length < 13 && sumtax_pay[0].length >= 9) {
          firstPage.drawText("2" + sumtax_pay[0], {
            x: 502 - 5 * (sumtax_pay[0].length - 3) - sumtax_pay[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        } else if (sumtax_pay[0].length < 9 && sumtax_pay[0].length >= 4) {
          firstPage.drawText("" + sumtax_pay[0], {
            x: 540 - 5 * (sumtax_pay[0].length - 2) - sumtax_pay[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        } else {
          firstPage.drawText("" + sumtax_pay[0], {
            x: 540 - 5 * (sumtax_pay[0].length - 1) - sumtax_pay[0].length,
            y: 181,
            size: 11,
            font: customFont,
            color: rgb(0, 0, 0),
          });
        }
        firstPage.drawText("." + sumtax_pay[1], {
          x: 545,
          y: 181,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        this.tax = this.formatNumber(element.tax_pay);
        this.ArabicNumberToText(this.tax);
        firstPage.drawText("" + this.texttax, {
          x: 250,
          y: 160,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        }); //ยอดรวม
        firstPage.drawText("", {
          x: 240,
          y: 145,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        }); //กองทุนรวมสงเคราะห์
        firstPage.drawText("" + element.social_pay, {
          x: 370,
          y: 145,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        }); //ประกันสังคม
        firstPage.drawText("", {
          x: 503,
          y: 145,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        }); //กองทุนสำรองเลี้ยงชีพ

        firstPage.drawText("X", {
          x: 85,
          y: 122,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        }); //ประกันสังคม
        // console.log("tw" + i);
        // console.log("t" + index);

        i += 742;

        k = index;
      });

      const pdfBytes = await pdfDoc.save();

      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      var fileName = "รายการภาษีหักณที่จ่าย" + chunk[0].emp_name + ".pdf";
      // console.log("fileName " + fileName);
      zip.file(fileName, blob);
    },
    createDownloadLink(blob, fileName) {
      const href = URL.createObjectURL(blob);
      return {
        href,
        download: fileName,
        text: `Download ${fileName}`,
      };
    },

    downloadWHT() {
      if (this.table_show_details.length > 0) {
        console.log(this.table_show_details);
        let contentLines = [];
        let lineNumber = 1;

        this.table_show_details.forEach((item) => {
          if (item.total_income1 > 0) {
            contentLines.push(
              `${lineNumber}|${item.idcard}|${item.prefix}|${item.firstName}|${item.lastName}|${this.dateformat(this.showdateend)}|401N|${this.numberDecimal(
                item.total_income1
              )}|${this.numberDecimal(item.total_tax1)}|1`
            );
            lineNumber++;
          }
          if (item.total_income2 > 0) {
            contentLines.push(
              `${lineNumber}|${item.idcard}|${item.prefix}|${item.firstName}|${item.lastName}|${this.dateformat(this.showdateend)}|402I|${this.numberDecimal(
                item.total_income2
              )}|${this.numberDecimal(item.total_tax2)}|1`
            );
            lineNumber++;
          }
        });

        const content = contentLines.join("\n");
        const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", "ภงด" + this.docno + this.getBranchName(this.selectedBranchShow) + this.dateformat(this.showdateend) + ".txt");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      }
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    back() {
      this.goto("payrolldoc/list");
    },
    dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    dateformatDMY(date) {
      const momentDate = moment(date);
      const day = momentDate.format("DD");
      const month = momentDate.format("MM");
      const year = momentDate.year() + 543;
      return `${day}${month}${String(year).slice(-2)}`;
    },
    dateformatMY(date) {
      const momentDate = moment(date);
      const month = momentDate.format("MM");
      const year = momentDate.year() + 543;
      return `${month}${String(year).slice(-2)}`;
    },
    downloadexcel() {
      var config = {
        raw: true,
        type: "string",
        s: {
          patternType: "solid",
          fgColor: { rgb: "FFFF00" },
          bgColor: { indexed: 64 },
        },
      };
      var payroll = XLSX.utils.table_to_sheet(document.getElementById("table_detail"), config);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, payroll, "payroll");
      XLSX.writeFile(wb, "payrolldetail.xlsx");
    },
    processContribute() {
      if (this.select_branch_contributors != "") {
        this.showContributorsDetail = "";
        this.data.forEach((data) => {
          if (data.deductSS != 0 && data.branch == this.select_branch_contributors) {
            let row = `<tr>
          <td>${data.idCard}</td>
          <td>${data.nameTitle}</td>
          <td>${data.firstName}</td>
          <td>${data.lastName}</td>
          <td style='text-align:right'>${data.salary}</td>
          <td style='text-align:right'>${data.deductSS}</td>
          </tr>`;
            this.showContributorsDetail += row;
          }
        });
      } else {
        this.showContributorsDetail = "";
        this.data.forEach((data) => {
          if (data.deductSS != 0) {
            let row = `<tr>
          <td>${data.idCard}</td>
          <td>${data.nameTitle}</td>
          <td>${data.firstName}</td>
          <td>${data.lastName}</td>
          <td style='text-align:right'>${data.salary}</td>
          <td style='text-align:right'>${data.deductSS}</td>
          </tr>`;
            this.showContributorsDetail += row;
          }
        });
      }
    },
    async getCopyDoc(pdfDoc, PDFDocument, existingPdfBytes, srcDoc) {
      const copypage = await pdfDoc.copyPages(srcDoc, [0]);
      // console.log("33333");
      return copypage;
    },
    ArabicNumberToText(Number) {
      // console.log("Number: ", Number);
      var Number = this.CheckNumber(Number);
      var NumberArray = new Array("ศูนย์", "หน่ึง", "สอง", "สาม", "ส่ี", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ");
      var DigitArray = new Array("", "สิบ", "ร้อย", "พัน", "หม่ืน", "แสน", "ล้าน");
      var BahtText = "";
      if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
      } else {
        if (Number - 0 > 9999999.9999) {
          return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
          Number = Number.split(".");
          if (Number[1].length > 0) {
            Number[1] = Number[1].substring(0, 2);
          }
          var NumberLen = Number[0].length - 0;
          for (var i = 0; i < NumberLen; i++) {
            var tmp = Number[0].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if (i == NumberLen - 1 && tmp == 1) {
                BahtText += "เอ็ด";
              } else if (i == NumberLen - 2 && tmp == 2) {
                BahtText += "ย่ี";
              } else if (i == NumberLen - 2 && tmp == 1) {
                BahtText += "";
              } else {
                BahtText += NumberArray[tmp];
              }
              BahtText += DigitArray[NumberLen - i - 1];
            }
          }
          BahtText += "บาท";
          if (Number[1] == "0" || Number[1] == "00") {
            BahtText += "ถ้วน";
          } else {
            var DecimalLen = Number[1].length - 0;
            for (var i = 0; i < DecimalLen; i++) {
              var tmp = Number[1].substring(i, i + 1) - 0;
              if (tmp != 0) {
                if (i == DecimalLen - 1 && tmp == 1) {
                  BahtText += "เอ็ด";
                } else if (i == DecimalLen - 2 && tmp == 2) {
                  BahtText += "ย่ี";
                } else if (i == DecimalLen - 2 && tmp == 1) {
                  BahtText += "";
                } else {
                  BahtText += NumberArray[tmp];
                }
                BahtText += DigitArray[DecimalLen - i - 1];
              }
            }
            BahtText += "สตางค์";
          }
          // console.log("BahtText: ", BahtText);
          this.texttax = BahtText;
          return BahtText;
        }
      }
    },
    CheckNumber(Number) {
      var decimal = false;
      Number = Number.toString();
      Number = Number.replace(/ |,|บาท|฿/gi, "");
      for (var i = 0; i < Number.length; i++) {
        if (Number[i] == ".") {
          decimal = true;
        }
      }
      if (decimal == false) {
        Number = Number + ".00";
      }
      // console.log("Number : ", Number);
      return Number;
    },
    downloadContribution() {
      if (this.select_branch_contributors != "") {
        this.showContributorsDetail = "";
        this.data.forEach((data) => {
          if (data.deductSS != 0 && data.branch == this.select_branch_contributors) {
            let row = `<tr>
          <td>${data.idCard}</td>
          <td>${data.nameTitle}</td>
          <td>${data.firstName}</td>
          <td>${data.lastName}</td>
          <td style='text-align:right'>${data.base_deduct_ss_cal}</td>
          <td style='text-align:right'>${data.deductSS}</td>
          </tr>`;
            this.showContributorsDetail += row;
          }
        });
      } else {
        this.showContributorsDetail = "";
        this.data.forEach((data) => {
          if (data.deductSS != 0) {
            let row = `<tr>
          <td>${data.idCard}</td>
          <td>${data.nameTitle}</td>
          <td>${data.firstName}</td>
          <td>${data.lastName}</td>
          <td style='text-align:right'>${data.base_deduct_ss_cal}</td>
          <td style='text-align:right'>${data.deductSS}</td>
          </tr>`;
            this.showContributorsDetail += row;
          }
        });
      }

      setTimeout(() => {
        if (this.showContributorsDetail != "") {
          var config = {
            raw: true,
            type: "string",
            s: {
              patternType: "solid",
              fgColor: { rgb: "FFFF00" },
              bgColor: { indexed: 64 },
            },
          };
          var branchName = this.getBranchName(this.select_branch_contributors);
          var payroll = XLSX.utils.table_to_sheet(document.getElementById("table_detail_contributor"), config);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, payroll, "0" + this.select_branch_contributors);
          XLSX.writeFile(wb, "เงินสมทบนำส่งสาขา" + branchName + "-" + this.dateformat(this.showdatestart) + "-" + this.dateformat(this.showdateend) + ".xlsx");
        }
      }, 1000);
    },
    getDataGen(data, count) {
      const dataStr = String(data);
      let processedData = dataStr.length > count ? dataStr.slice(0, count) : dataStr.padStart(count, "0");
      return processedData;
    },
    getDataGenCompany(data, count) {
      const dataStr = String(data);
      let processedData = dataStr.length > count ? dataStr.slice(0, count) : dataStr.padEnd(count, " ");
      return processedData;
    },
    async downloadContributionTxt() {
      console.log(this.select_branch_contributors);
      console.log(this.acc_no);
      console.log(this.companyName);
      console.log(this.dateformatDMY(this.showdateend));
      console.log(this.dateformatMY(this.showdateend));
      console.log(this.ss_rate);

      var total_emp = 0;
      var total_wages = 0;
      var total_paid = 0;
      var total_paid_by_employee = 0;
      var total_paid_by_employer = 0;

      var header = "";
      var body = "";

      if (this.select_branch_contributors != "") {
        this.showContributorsDetail = "";
        this.data.forEach((data) => {
          console.log(data);
          var salary = data.base_deduct_ss_cal;
          if (data.deductSS != 0 && data.branch == this.select_branch_contributors) {
            total_emp += 1;
            total_paid_by_employee += data.deductSS;
            total_paid_by_employer += data.deductSS;

            total_wages += salary;

            var title = "3";
            if (data.nameTitle == "นาย") {
              title = "3";
            } else if (data.nameTitle == "นาง") {
              title = "5";
            } else if (data.nameTitle == "นางสาว") {
              title = "4";
            }

            body +=
              "2" +
              this.getDataGen(data.idCard, 13) +
              this.getDataGen(title, 3) +
              this.getDataGenCompany(data.firstName, 30) +
              this.getDataGenCompany(data.lastName, 35) +
              this.getDataGen(salary.toFixed(2).replace(".", ""), 14) +
              this.getDataGen(data.deductSS.toFixed(2).replace(".", ""), 12) +
              this.getDataGenCompany("", 27) +
              "\r\n";
          }
        });

        total_paid = total_paid_by_employee + total_paid_by_employer;

        header +=
          "1" +
          this.acc_no +
          this.getDataGen(this.select_branch_contributors, 6) +
          this.getDataGen(this.dateformatDMY(this.showdateend), 6) +
          this.getDataGen(this.dateformatMY(this.showdateend), 4) +
          this.getDataGenCompany(this.companyName, 45) +
          this.getDataGen(this.ss_rate.toFixed(2).replace(".", ""), 4) +
          this.getDataGen(total_emp, 6) +
          this.getDataGen(total_wages.toFixed(2).replace(".", ""), 15) +
          this.getDataGen(total_paid.toFixed(2).replace(".", ""), 14) +
          this.getDataGen(total_paid_by_employee.toFixed(2).replace(".", ""), 12) +
          this.getDataGen(total_paid_by_employer.toFixed(2).replace(".", ""), 12) +
          "\r\n";
      }

      // Combine header and body into a single string
      const content = header + body;
      const filename = `นำส่งประกันสังคมงวดที่ ${this.dateformatMY(this.showdateend)}.txt`;

      try {
        // เรียกใช้ฟังก์ชัน downloadTextFile
        const response = await DocumentService.downloadTextFile(content, filename);

        // สร้าง URL จาก blob ที่ได้รับมา (ใช้ Windows-874)
        const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/plain;charset=windows-874" }));

        // สร้างลิงก์เพื่อดาวน์โหลดไฟล์
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); // ชื่อไฟล์ที่ต้องการให้ดาวน์โหลด
        document.body.appendChild(link);
        link.click();

        // ล้างข้อมูล
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },

    async whtForm() {
      const url = "/static/pdf/200360_WHT1.pdf";
      const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      pdfDoc.registerFontkit(fontkit);
      const urlfont = "/static/Sarabun-Regular.ttf";
      const fontBytes = await fetch(urlfont).then((res) => res.arrayBuffer());
      const customFont = await pdfDoc.embedFont(fontBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();
      let v = this;

      if (v.taxpayer_number != null) {
        firstPage.drawText("" + v.taxpayer_number.substring(0, 1), {
          x: 164,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(1, 2), {
          x: 180,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(2, 3), {
          x: 192,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(3, 4), {
          x: 204,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(4, 5), {
          x: 215,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(5, 6), {
          x: 231,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(6, 7), {
          x: 243,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(7, 8), {
          x: 254,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(8, 9), {
          x: 265,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(9, 10), {
          x: 276,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(10, 11), {
          x: 294,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(11, 12), {
          x: 306,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText("" + v.taxpayer_number.substring(12, 13), {
          x: 322,
          y: 738,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }
      //ชื่อบริษัท
      firstPage.drawText("" + this.companyName, {
        x: 60,
        y: 693,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });
      //อาคาร
      if (this.companybuilding == "" || this.companybuilding == null) {
        firstPage.drawText("-", { x: 110, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companybuilding, { x: 110, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }
      //ห้องที่
      if (this.companyroom_no == "" || this.companyroom_no == null) {
        firstPage.drawText("-", { x: 195, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyroom_no, { x: 190, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }
      //ชั้นที่
      if (this.companyfloor == "" || this.companyfloor == null) {
        firstPage.drawText("-", { x: 230, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyfloor, { x: 230, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }

      //หมู่บ้าน
      if (this.companyvillage == "" || this.companyvillage == null) {
        firstPage.drawText("-", { x: 285, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyvillage, { x: 275, y: 675, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }

      //ที่อยู่
      if (this.companyhouse_no == "" || this.companyhouse_no == null) {
        firstPage.drawText("-", { x: 80, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyhouse_no, { x: 80, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }

      //หมู่ที่
      if (this.companyvillage_no == "" || this.companyvillage_no == null) {
        firstPage.drawText("-", { x: 160, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyvillage_no, { x: 160, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }

      //ตรอก/ซอย
      if (this.companyalley_lane == "" || this.companyalley_lane == null) {
        firstPage.drawText("-", { x: 230, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyalley_lane, { x: 230, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }
      firstPage.drawText("-", { x: 310, y: 660, size: 11, font: customFont, color: rgb(0, 0, 0) });

      //ถนน
      if (this.companyroad == "" || this.companyroad == null) {
        firstPage.drawText("-", { x: 80, y: 645, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companyroad, { x: 80, y: 645, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }
      //ตำบล
      if (this.companysubdistrict_subarea == "" || this.companysubdistrict_subarea == null) {
        firstPage.drawText("-", { x: 250, y: 645, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companysubdistrict_subarea, { x: 250, y: 645, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }
      //อำเภอ
      if (this.companysubdistrict_subarea == "" || this.companysubdistrict_subarea == null) {
        firstPage.drawText("-", { x: 120, y: 628, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + this.companydistrict_area, { x: 120, y: 628, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }

      //เชียงใหม่
      firstPage.drawText("" + this.companyprovince, { x: 250, y: 628, size: 11, font: customFont, color: rgb(0, 0, 0) });
      //รหัสไปรษณีย์
      firstPage.drawText("" + this.companypostcode.substring(0, 1), { x: 94, y: 611, size: 11, font: customFont, color: rgb(0, 0, 0) });
      firstPage.drawText("" + this.companypostcode.substring(1, 2), { x: 104, y: 611, size: 11, font: customFont, color: rgb(0, 0, 0) });
      firstPage.drawText("" + this.companypostcode.substring(2, 3), { x: 115, y: 611, size: 11, font: customFont, color: rgb(0, 0, 0) });
      firstPage.drawText("" + this.companypostcode.substring(3, 4), { x: 126, y: 611, size: 11, font: customFont, color: rgb(0, 0, 0) });
      firstPage.drawText("" + this.companypostcode.substring(4, 5), { x: 136, y: 611, size: 11, font: customFont, color: rgb(0, 0, 0) });
      //จำนวนผู้เสียภาษี
      firstPage.drawText("" + v.person1, {
        x: 342,
        y: 419,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });

      firstPage.drawText("" + v.person2, {
        x: 342,
        y: 314,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });

      //จำนวน เงินทั้งสิ้น
      //   firstPage.drawText("" + this.thousandSep(v.totalEarning), {
      //   x: 405,
      //   y: 420,
      //   size: 11,
      //   font: customFont,
      //   color: rgb(0, 0, 0)
      // });
      //จำนวน เงินทั้งสิ้น
      console.log("v.totalEarning1", v.person2);
      console.log("v.totalEarning2", v.totalEarning2);

      let totalEarning = this.thousandSep(v.totalEarning1).split(".");
      if (totalEarning[0].length >= 13) {
        firstPage.drawText("" + totalEarning[0], { x: 435 - 5 * (totalEarning[0].length - 4) - totalEarning[0].length, y: 419, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else if (totalEarning[0].length < 13 && totalEarning[0].length >= 9) {
        firstPage.drawText("" + totalEarning[0], { x: 435 - 5 * (totalEarning[0].length - 3) - totalEarning[0].length, y: 419, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else if (totalEarning[0].length < 9 && totalEarning[0].length >= 4) {
        firstPage.drawText("" + totalEarning[0], { x: 435 - 5 * (totalEarning[0].length - 2) - totalEarning[0].length, y: 419, size: 11, font: customFont, color: rgb(0, 0, 0) });
      } else {
        firstPage.drawText("" + totalEarning[0], { x: 435 - 5 * (totalEarning[0].length - 1) - totalEarning[0].length, y: 419, size: 11, font: customFont, color: rgb(0, 0, 0) });
      }

      firstPage.drawText("." + totalEarning[1], { x: 440, y: 419, size: 11, font: customFont, color: rgb(0, 0, 0) });

      let totalEarning2 = this.thousandSep(v.totalEarning2).split(".");
      if (totalEarning2[0].length >= 13) {
        firstPage.drawText("" + totalEarning2[0], {
          x: 435 - 5 * (totalEarning2[0].length - 4) - totalEarning2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totalEarning2[0].length < 13 && totalEarning2[0].length >= 9) {
        firstPage.drawText("" + totalEarning2[0], {
          x: 435 - 5 * (totalEarning2[0].length - 3) - totalEarning2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totalEarning2[0].length < 9 && totalEarning2[0].length >= 4) {
        firstPage.drawText("" + totalEarning2[0], {
          x: 435 - 5 * (totalEarning2[0].length - 2) - totalEarning2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else {
        firstPage.drawText("" + totalEarning2[0], {
          x: 435 - 5 * (totalEarning2[0].length - 1) - totalEarning2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      firstPage.drawText("." + totalEarning2[1], { x: 440, y: 314, size: 11, font: customFont, color: rgb(0, 0, 0) });

      //จำนวนภาษีทั้งสิ้น
      let totaldeduct_tax = this.thousandSep(v.totalDeductTax1).split(".");
      if (totaldeduct_tax[0].length >= 13) {
        firstPage.drawText("" + totaldeduct_tax[0], {
          x: 522 - 5 * (totaldeduct_tax[0].length - 4) - totaldeduct_tax[0].length,
          y: 419,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totaldeduct_tax[0].length < 13 && totaldeduct_tax[0].length >= 9) {
        firstPage.drawText("" + totaldeduct_tax[0], {
          x: 522 - 5 * (totaldeduct_tax[0].length - 3) - totaldeduct_tax[0].length,
          y: 419,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totaldeduct_tax[0].length < 9 && totaldeduct_tax[0].length >= 4) {
        firstPage.drawText("" + totaldeduct_tax[0], {
          x: 522 - 5 * (totaldeduct_tax[0].length - 2) - totaldeduct_tax[0].length,
          y: 419,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else {
        firstPage.drawText("" + totaldeduct_tax[0], {
          x: 522 - 5 * (totaldeduct_tax[0].length - 1) - totaldeduct_tax[0].length,
          y: 419,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      firstPage.drawText("." + totaldeduct_tax[1], { x: 527, y: 419, size: 11, font: customFont, color: rgb(0, 0, 0) });

      let totaldeduct_tax2 = this.thousandSep(v.totalDeductTax2).split(".");
      if (totaldeduct_tax2[0].length >= 13) {
        firstPage.drawText("" + totaldeduct_tax2[0], {
          x: 522 - 5 * (totaldeduct_tax2[0].length - 4) - totaldeduct_tax2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totaldeduct_tax2[0].length < 13 && totaldeduct_tax2[0].length >= 9) {
        firstPage.drawText("" + totaldeduct_tax2[0], {
          x: 522 - 5 * (totaldeduct_tax2[0].length - 3) - totaldeduct_tax2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totaldeduct_tax2[0].length < 9 && totaldeduct_tax2[0].length >= 4) {
        firstPage.drawText("" + totaldeduct_tax2[0], {
          x: 522 - 5 * (totaldeduct_tax2[0].length - 2) - totaldeduct_tax2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else {
        firstPage.drawText("" + totaldeduct_tax2[0], {
          x: 522 - 5 * (totaldeduct_tax2[0].length - 1) - totaldeduct_tax2[0].length,
          y: 314,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      firstPage.drawText("." + totaldeduct_tax2[1], { x: 527, y: 314, size: 11, font: customFont, color: rgb(0, 0, 0) });
      //   firstPage.drawText("" + this.thousandSep(v.totaldeduct_tax2), {
      //   x: 505,
      //   y: 420,
      //   size: 11,
      //   font: customFont,
      //   color: rgb(0, 0, 0)
      // });
      firstPage.drawText("" + (v.person1 + v.person2), {
        x: 342,
        y: 279,
        size: 11,
        font: customFont,
        color: rgb(0, 0, 0),
      });
      //จำนวน เงินทั้งสิ้น
      //   firstPage.drawText("" + this.thousandSep(v.totalEarning), {
      //   x: 405,
      //   y: 420,
      //   size: 11,
      //   font: customFont,
      //   color: rgb(0, 0, 0)
      // });
      //จำนวนรวมเงินทั้งสิ้น
      let totalsumEarning = this.thousandSep(v.totalEarning1 + v.totalEarning2).split(".");
      if (totalEarning[0].length >= 13) {
        firstPage.drawText("" + totalsumEarning[0], {
          x: 435 - 5 * (totalsumEarning[0].length - 4) - totalsumEarning[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totalsumEarning[0].length < 13 && totalEarning[0].length >= 9) {
        firstPage.drawText("" + totalsumEarning[0], {
          x: 435 - 5 * (totalsumEarning[0].length - 3) - totalsumEarning[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totalsumEarning[0].length < 9 && totalsumEarning[0].length >= 4) {
        firstPage.drawText("" + totalsumEarning[0], {
          x: 435 - 5 * (totalsumEarning[0].length - 2) - totalsumEarning[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else {
        firstPage.drawText("" + totalsumEarning[0], {
          x: 435 - 5 * (totalsumEarning[0].length - 1) - totalsumEarning[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      firstPage.drawText("." + totalsumEarning[1], { x: 440, y: 279, size: 11, font: customFont, color: rgb(0, 0, 0) });

      //จำนวนรวมภาษีทั้งสิ้น
      let totalsumdeduct_tax = this.thousandSep(v.totalDeductTax1 + v.totalDeductTax2).split(".");
      if (totalsumdeduct_tax[0].length >= 13) {
        firstPage.drawText("" + totalsumdeduct_tax[0], {
          x: 522 - 5 * (totalsumdeduct_tax[0].length - 4) - totalsumdeduct_tax[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totalsumdeduct_tax[0].length < 13 && totalsumdeduct_tax[0].length >= 9) {
        firstPage.drawText("" + totalsumdeduct_tax[0], {
          x: 522 - 5 * (totalsumdeduct_tax[0].length - 3) - totalsumdeduct_tax[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (totalsumdeduct_tax[0].length < 9 && totalsumdeduct_tax[0].length >= 4) {
        firstPage.drawText("" + totalsumdeduct_tax[0], {
          x: 522 - 5 * (totalsumdeduct_tax[0].length - 2) - totalsumdeduct_tax[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else {
        firstPage.drawText("" + totalsumdeduct_tax[0], {
          x: 522 - 5 * (totalsumdeduct_tax[0].length - 1) - totalsumdeduct_tax[0].length,
          y: 279,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      firstPage.drawText("." + totalsumdeduct_tax[1], { x: 527, y: 279, size: 11, font: customFont, color: rgb(0, 0, 0) });
      //จำนวนรวมภาษีทั้งสิ้น
      let finaltotaldeduct_tax = this.thousandSep(v.totalDeductTax1 + v.totalDeductTax2).split(".");
      if (totalsumdeduct_tax[0].length >= 13) {
        firstPage.drawText("" + finaltotaldeduct_tax[0], {
          x: 522 - 5 * (finaltotaldeduct_tax[0].length - 4) - finaltotaldeduct_tax[0].length,
          y: 243,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (finaltotaldeduct_tax[0].length < 13 && finaltotaldeduct_tax[0].length >= 9) {
        firstPage.drawText("" + totafinaltotaldeduct_taxlsumdeduct_tax[0], {
          x: 522 - 5 * (finaltotaldeduct_tax[0].length - 3) - finaltotaldeduct_tax[0].length,
          y: 243,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else if (finaltotaldeduct_tax[0].length < 9 && finaltotaldeduct_tax[0].length >= 4) {
        firstPage.drawText("" + finaltotaldeduct_tax[0], {
          x: 522 - 5 * (finaltotaldeduct_tax[0].length - 2) - finaltotaldeduct_tax[0].length,
          y: 243,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      } else {
        firstPage.drawText("" + finaltotaldeduct_tax[0], {
          x: 522 - 5 * (finaltotaldeduct_tax[0].length - 1) - finaltotaldeduct_tax[0].length,
          y: 243,
          size: 11,
          font: customFont,
          color: rgb(0, 0, 0),
        });
      }

      firstPage.drawText("." + finaltotaldeduct_tax[1], { x: 527, y: 243, size: 11, font: customFont, color: rgb(0, 0, 0) });

      const pdfBytes = await pdfDoc.save();
      const downloadBlob = (data, fileName, mimeType) => {
        const blob = new Blob([data], {
          type: mimeType,
        });
        const url = window.URL.createObjectURL(blob);
        downloadURL(url, fileName);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      };

      const downloadURL = (data, fileName) => {
        const a = document.createElement("a");
        a.href = data;
        a.download = fileName;
        document.body.appendChild(a);
        a.style.display = "none";
        a.click();
        a.remove();
      };

      downloadBlob(pdfBytes, this.companyName + this.dateformat(this.showdatestart) + "-" + this.dateformat(this.showdateend) + ".pdf", "application/pdf");
    },
    formatname(name) {
      let value = name.split("(");
      let n = value[0];
      let nickname = "";
      // console.log(n, "dddd");
      // console.log(value);
      if (value[1] != "" && value[1] != undefined) {
        let arrnickname = value[1].split(")");
        nickname = arrnickname[0];
        if (nickname == "") {
          return n;
        } else {
          return n;
        }
      } else if (value[1] == undefined) {
        return n;
      }
    },
    sortByName(data) {
      return data.sort((a, b) => {
        // Prioritize "เงินเดือน"
        if (a.name === "เงินเดือน" && b.name !== "เงินเดือน") {
          return -1;
        } else if (a.name !== "เงินเดือน" && b.name === "เงินเดือน") {
          return 1;
        }

        // For other names, sort alphabetically
        return a.name.localeCompare(b.name, "th");
      });
    },
    showPayslip() {
      var checkedValues = $('input[class="checkit"]:checked')
        .map(function() {
          return this.value;
        })
        .get();
      if (checkedValues != "") {
        if (localStorage._company_guid == "NPDqsBJvc81xUdwRrgYvWIjdJvZpuuZBjoOe") {
          window.open("#/PeviewPDFSingha/" + this.docno + "/" + checkedValues.toString(), "_blank");
        } else {
          window.open("#/PeviewPDF/" + this.docno + "/" + checkedValues.toString(), "_blank");
        }
      }
      console.log(this.docno);
      console.log(checkedValues);
    },
    showcontributions() {
      this.dialog_contribution = true;
    },
    showWHT() {
      this.showMainTable = !this.showMainTable;
      this.processBranch();
    },
    emailPayslip() {
      var v = this;
      var checkedValues = $('input[class="checkit"]:checked')
        .map(function() {
          return this.value;
        })
        .get();
      if (checkedValues != "") {
        //
        //this.emp_code = checkedValues.toString();
        //   console.log(checkedValues);
        this.progressbar.msg = this.load_msg;
        this.progressbar.query = true;
        this.progressbar.show = true;
        this.progressbar.value = 0;
        this.dialog_loading = true;
        let arr = [];
        checkedValues.forEach((element) => {
          // console.log(element);
          let rowz = this.data.filter((c) => c.code == element);
          if (rowz.length > 0) {
            arr.push(rowz[0]);
          }
        });
        this.emp_select = arr;
        this.getCompany();
        console.log(this.emp_select);
      }
    },
    async getCompany() {
      NProgress.start();
      try {
        let tmpResult = await SettingService.getDataCompany();
        this.email_payslip.ltdName = tmpResult.data.content[0].companyname;
        setTimeout(() => {
          this.getPDFByEmpID();
        }, 1000);
      } catch (err) {
        console.log(err);
        this.progressbar.msg = this.load_msg;
        this.progressbar.query = false;
        this.progressbar.show = false;
        this.progressbar.value = 0;
        this.dialog_loading = false;
      }
      NProgress.done();
    },
    getUniqueHeaders(data) {
      let headers = new Set();
      let v = this;

      data.forEach((item) => {
        item.incomeAndExpenses.forEach((entry) => {
          let branchname = "";
          if (entry.branchPay != "'") {
            if (v.branch_items.filter((item) => item.code == entry.branchPay).length > 0) {
              branchname = v.branch_items.filter((item) => item.code == entry.branchPay)[0].name;
            }
          }
          if (entry.tranFlag === 0) {
            let header = {
              code: entry.branchPay,
              name: entry.name,
              branchname: branchname,
              label: entry.name + (branchname ? ":" + branchname : ""),
            };
            headers.add(JSON.stringify(header)); // Use JSON string to ensure uniqueness
          }
        });
      });

      return Array.from(headers)
        .map((headerStr) => JSON.parse(headerStr))
        .sort((a, b) => {
          let branchPayComparison = (a.code || "").localeCompare(b.code || "");
          if (branchPayComparison !== 0) return branchPayComparison;
          return a.name.localeCompare(b.name);
        });
    },
    numberDecimal(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;

      return x1 + x2;
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    async getPDFByEmpID() {
      let v = this;
      NProgress.start();
      this.send_email = [];
      this.progressbar.msg = this.send_msg;
      this.progressbar.query = false;
      try {
        let tmpResult = this.emp_select;
        // gen items
        var maxlength = tmpResult.length;
        await tmpResult.forEach(async function(element, index) {
          v.progressbar.value = ((index + 1) / maxlength) * 100;
          if (element.email != null) {
            if (element.email.length > 0) {
              var code = element.code; //รหัสพนักงาน
              var name = element.name.split("(")[0]; //ชื่อพนักงาน
              var date = moment(element.toDate).format("DD/MM/YYYY"); //วันที่
              var email = element.email;
              var departmentname = element.department_name; //ตำแหน่ง
              var salary = v.thousandSep(element.salary); //เงินเดือน
              var deductSS = v.thousandSep(element.deductSS); //รายได้สุทธิ
              var total_balance = v.thousandSep(element.total_balance); //รายได้สุทธิ
              var accumulatedIncome = v.thousandSep(element.accumulatedIncome); //รายได้สะสม
              var cumulativeSS = v.thousandSep(element.cumulativeSS); //ประกันสะสม
              var cumulativeTax = v.thousandSep(element.cumulativeTax); //ภาษีสะสม
              var totalEarning = v.thousandSep(element.totalEarning); //รายได้รวม
              var totalDeduct = v.thousandSep(element.totalDeduct); //รวมรายจ่าย
              var incomeAndExpenses = element.incomeAndExpenses; //รวมรายจ่ายและรายได้
              var deduct_tax = v.thousandSep(element.deduct_tax); //ภาษี
              var income = "";
              var incomeAmount = "";
              var expenses = "";
              var expensesAmount = "";
              var spaceexpenses = "";
              var spaceincome = "";
              var space = "";
              for (let index = 0; index < incomeAndExpenses.length; index++) {
                if (incomeAndExpenses[index].tranFlag === 0) {
                  income += `\n` + incomeAndExpenses[index].name;
                  incomeAmount += `\n` + v.thousandSep(incomeAndExpenses[index].amount);
                  spaceincome += `\n`;
                } else if (incomeAndExpenses[index].tranFlag === 1) {
                  expenses += `\n` + incomeAndExpenses[index].name;
                  expensesAmount += `\n` + v.thousandSep(incomeAndExpenses[index].amount);
                  spaceexpenses += `\n`;
                } else if (incomeAndExpenses[index].tranFlag !== 0 && incomeAndExpenses[index].tranFlag !== 1) {
                  space += "";
                }
              }

              if (deduct_tax !== "0.00") {
                expenses += `\nภาษี`;
                expensesAmount += `\n` + deduct_tax;
                spaceexpenses += `\n`;
              }

              let jsonData = v.genSlipJson(
                "none",
                v.email_payslip.ltdName,
                code,
                date,
                name,
                spaceincome,
                departmentname,
                space,
                spaceexpenses,
                total_balance,
                totalEarning,
                income,
                salary,
                incomeAmount,
                totalDeduct,
                expenses,
                deductSS,
                expensesAmount,
                accumulatedIncome,
                cumulativeTax,
                cumulativeSS
              );

              var pdfMake = require("pdfmake/build/pdfmake.js");
              //pdfMake.setFonts(fonts);
              // if (pdfMake.vfs == undefined) {
              //   var pdfFonts = require("pdfmake/build/vfs_fonts.js");
              //   pdfMake.vfs = pdfFonts.pdfMake.vfs;
              // }

              pdfMake.fonts = {
                Sarabun: {
                  normal: "https://fonts.gstatic.com/s/sarabun/v12/DtVjJx26TKEr37c9WBJDnlQN9gk.ttf",
                  bold: "https://fonts.gstatic.com/s/sarabun/v12/DtVmJx26TKEr37c9YK5sulwm6gDXvwE.ttf",
                  italics: "https://fonts.gstatic.com/s/sarabun/v12/DtVhJx26TKEr37c9aBBJmnYI5gnOpg.ttf",
                  bolditalics: "https://fonts.gstatic.com/s/sarabun/v12/DtVkJx26TKEr37c9aBBxJlks7iLSrwFUlw.ttf",
                },
              };
              let docDefinition = {
                content: jsonData,
                styles: {
                  header: {
                    fontSize: 11,
                    bold: true,
                    margin: [0, 0, 0, 3],
                  },
                  subheader: {
                    fontSize: 11,
                    bold: true,
                  },
                },
                defaultStyle: {
                  font: "Sarabun",
                  fontSize: 9,
                },
              };
              v.email_payslip.pdfDocGen = "";
              v.email_payslip.pdfDocGen = pdfMake.createPdf(docDefinition);
              await v.email_payslip.pdfDocGen.getDataUrl((data) => {
                //console.log("email " + email);
                var detail = data.replace("data:application/pdf;base64,", "");
                v.send_email.push({
                  email: email,
                  slip_date: date,
                  name: name,
                  shopname: localStorage._company_name,
                  data: detail,
                });
              });
            }
          }
        });
        //console.log(this.send_email);
        setTimeout(() => {
          v.postSendEmail();
        }, 1000);
      } catch (err) {
        console.log(err);
        this.progressbar.msg = this.load_msg;
        this.progressbar.query = false;
        this.progressbar.show = false;
        this.progressbar.value = 0;
        this.dialog_loading = false;
      }
      NProgress.done();
    },
    postSendEmail() {
      console.log("sending");
      console.log(this.send_email);

      PayrollService.postSendEmail(this.send_email)
        .then((res) => {
          console.log(res);
          this.progressbar.msg = this.load_msg;
          this.progressbar.query = false;
          this.progressbar.show = false;
          this.progressbar.value = 0;
          this.dialog_loading = false;
          this.snack_model.status = true;
          this.snack_model.type = "success";
          this.snack_model.msg = "Send email success";
        })
        .catch((err) => {
          console.log(err);
          this.progressbar.msg = this.load_msg;
          this.progressbar.query = false;
          this.progressbar.show = false;
          this.progressbar.value = 0;
          this.dialog_loading = false;
        });
    },
    genSlipJson(
      param,
      ltdName,
      code,
      date,
      name,
      spaceincome,
      departmentname,
      space,
      spaceexpenses,
      total_balance,
      totalEarning,
      income,
      salary,
      incomeAmount,
      totalDeduct,
      expenses,
      deductSS,
      expensesAmount,
      accumulatedIncome,
      cumulativeTax,
      cumulativeSS
    ) {
      let jSonResult = [
        {
          columns: [
            {
              text: ltdName,
              style: "header",
              alignment: "center",
              pageBreak: param,
            },
          ],
        },
        {
          columns: [
            {
              text: "ใบจ่ายเงินเดือน",
              style: "header",
              alignment: "center",
            },
          ],
        },
        {
          columns: [
            {
              text: "รหัสพนักงาน:" + code,
              style: "subheader",
              alignment: "left",
            },
          ],
        },
        {
          columns: [
            {
              width: 150,
              table: {
                widths: [70, 70],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "วันที่ : " + date + "\n" + "ชื่อ :" + name + "\n\n" + spaceincome + "แผนก :" + departmentname + "\n\n\n" + space + spaceexpenses,
                      margin: [0, 0, 0, 15],
                      colSpan: 2,
                    },
                    { text: "" },
                  ],

                  [{ text: "รายได้สุทธิ", alignment: "center" }, { text: "ผู้รับเงิน", alignment: "center" }],
                  [{ text: total_balance, alignment: "center" }, { text: "____________", alignment: "center" }],
                ],
              },
            },
            {
              width: 250,
              margin: [15, 0, 0, 0],
              table: {
                widths: [80, 10, 60, 100, 60],
                headerRows: 1,
                body: [
                  [
                    { text: "รายได้", colSpan: 4, alignment: "center" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    {
                      text: "รายได้รวม" + "\n\n" + spaceincome + totalEarning,
                      rowSpan: 2,
                      alignment: "center",
                    },
                  ],
                  [
                    { text: "เงินเดือน" + income },
                    {
                      text: salary + incomeAmount + "\n\n",
                      colSpan: 3,
                    },
                  ],
                  [
                    { text: "รายจ่าย", colSpan: 4, alignment: "center" },
                    { text: "" },
                    { text: "" },
                    { text: "" },
                    {
                      text: "รวมรายจ่าย" + "\n\n" + spaceexpenses + totalDeduct,
                      rowSpan: 2,
                      alignment: "center",
                    },
                  ],
                  [
                    { text: "ประกันสังคม" + expenses },
                    {
                      text: deductSS + expensesAmount + "\n\n",
                      colSpan: 3,
                    },
                  ],
                  [
                    { text: "รายได้สะสม", colSpan: 2, alignment: "center" },
                    { text: "" },
                    { text: "ภาษีสะสม", alignment: "center" },
                    { text: "เงินประกันสังคมสะสมต่อปี", alignment: "center" },

                    { text: "รายได้สุทธิ", alignment: "center" },
                  ],
                  [
                    {
                      text: accumulatedIncome,
                      colSpan: 2,
                      alignment: "center",
                    },
                    { text: "" },
                    { text: cumulativeTax, alignment: "center" },
                    { text: cumulativeSS, alignment: "center" },

                    { text: total_balance, alignment: "center" },
                  ],
                ],
              },
            },
          ],
        },
      ];
      return jSonResult;
    },
    createpdf() {
      let v = this;
    },
    doCopyTable() {
      if (this.showMainTable) {
        let el = document.getElementById("table_detail");
        let body = document.body;
        let range;
        let sel;
        if (document.createRange && window.getSelection) {
          range = document.createRange();
          sel = window.getSelection();
          sel.removeAllRanges();
          try {
            range.selectNodeContents(el);
            sel.addRange(range);
          } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
          }
        }
        document.execCommand("Copy");
        alert("Copy Table to Clipboard");
      } else {
        let el = document.getElementById("table_detail_2");
        let body = document.body;
        let range;
        let sel;
        if (document.createRange && window.getSelection) {
          range = document.createRange();
          sel = window.getSelection();
          sel.removeAllRanges();
          try {
            range.selectNodeContents(el);
            sel.addRange(range);
          } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
          }
        }
        document.execCommand("Copy");
        alert("Copy Table to Clipboard");
      }
    },
    async ListDetailByDocNo(doc_no, processCount) {
      this.progress = 0;
      var v = this;
      const size = 100;
      const totalChunks = Math.ceil(processCount / size);
      let completedChunks = 0;
      this.dialog_loading_detail = true;
      var dataWaitList = [];
      this.data = [];
      for (let i = 0; i < totalChunks; i++) {
        console.log("Processing chunk", i);
        try {
          const res = await PayrollService.getPayrollDetailByDocNoPage(doc_no, i, size);
          console.log("Batch import successful", res);
          if (res.data.length > 0) {
            res.data.forEach((element) => {
              if (element.isResign == false) {
                this.data.push(element);
              } else if (element.isResign == true && element.totalEarning > 0) {
                this.data.push(element);
              }
            });
          }
          completedChunks++;
          this.updateProgressBar(completedChunks, totalChunks);
        } catch (err) {
          console.error(err);
          this.dialog_loading_detail = false;
          this.snackbar = true;
          this.errmsg = err.message;
          break; // Stop processing if there is an error
        }
      }
      if (completedChunks === totalChunks) {
        console.log("All chunks processed successfully");
        v.dialog_loading_detail = false;
        if (this.data.length > 0) {
          this.display_table(this.data);
          this.processBranch();
        }
      }
    },
    updateProgressBar(completedChunks, totalChunks) {
      this.progress = Math.round((completedChunks / totalChunks) * 100);
    },
    display_table(dataWaitList) {
      var v = this;
      console.log("ListDetailByDocNo", dataWaitList);

      this.headVat = [];
      if (dataWaitList.length > 0) {
        if (dataWaitList[0].branchDetails != null && dataWaitList[0].branchDetails != "") {
          this.data_by_branch = JSON.parse(dataWaitList[0].branchDetails);
        }
      }
      console.log(" this.data_by_branch  ", this.data_by_branch);

      this.headReceive = this.getUniqueHeaders(dataWaitList);
      this.headReceive = this.getUniqueHeaders(dataWaitList);

      this.headReceive = this.sortByName(this.headReceive);

      // this.headReceive.forEach((element) => {
      //   this.headVat.push({ code: element.code, name: element.branchname });
      // });

      this.branch_items.forEach((element) => {
        if (element.code != "") {
          this.headVat.push({ code: element.code, name: element.name });
        }
      });

      const uniqueData = this.headVat.filter((v, i, a) => a.findIndex((t) => t.code === v.code) === i);

      this.headVat = uniqueData;

      console.log(this.headReceive);
      console.log("this.headVat", this.headVat);
      this.checklisttypepayment();
      this.showdatestart = this.data[0].fromDate;
      this.showdateend = this.data[0].toDate;
      setTimeout(() => {
        this.setShowDetail(this.data);
      }, 1000);
    },
    groupByPaymentType(array, key) {
      let list = {};
      let keylists = {};
      let result = {};
      array.forEach((item) => {
        let keyName = item[key];

        if (item.paymentType == "" || item.paymentType == undefined) {
          //keyName = "ไม่มีชื่อธนาคาร";
        }

        //console.log('item.paymentType ' +item.paymentType)
        if (item.paymentType == 0 && item.bankCode != "") {
          keyName = "เงินโอน";
        } else if (item.paymentType == 1) {
          keyName = "พร้อมเพย์";
        } else if (item.paymentType == 2) {
          keyName = "เงินสด";
        } else if (item.paymentType == 3) {
          keyName = "อื่นๆ";
        } else {
          keyName = "อื่นๆ";
        }
        if (!list[item.paymentType]) {
          //list[item.bankName] = "ไม่มีชื่อธนาคาร";
        }
        if (!result[keyName]) {
          result[keyName] = [];
        }
        //   console.log('item.paymentType ' +item.paymentType)
        //  console.log('keyName ' +keyName)
        //    console.log('list[item.paymentType] ' +list[item.paymentType])
        //item.paymentType = list[item.paymentType];
        result[keyName].push(item);
      });
      return result;
    },
    checklisttypepayment() {
      this.listpaymenttype = this.groupByPaymentType(this.data, "paymentType");
      console.log("listpaymenttype: ", this.listpaymenttype);
      for (var key in this.listpaymenttype) {
        this.typepayment.push(key);
      }
      //console.log("typepayment: ", this.typepayment);
    },
    documentbank() {
      let v = this;
      if (v.checktypepayment != null) {
        this.dialog_create = true;
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกประเภทการจ่ายเงิน";
        this.snack_model.type = "error";
      }
    },

    documentother() {
      let v = this;
      if (v.checktypepayment != null) {
        this.dialog_create_other = true;
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกประเภทการจ่ายเงิน";
        this.snack_model.type = "error";
      }
    },
    downloadtext(data) {
      console.log(data);
      var element = document.createElement("a");
      var textDetail = "";
      var textHead = "";
      var textFoot = "";
      var sumMoney = 0;
      var docDate = "";
      data.forEach((ele, index) => {
        console.log(ele);
        if (index == 0) {
          var diffComName = 25 - this.company_account_name.length;
          var companyName = this.company_account_name;
          for (var r = 0; r < diffComName; r++) {
            companyName += " ";
          }
          textHead = `H000001011${this.company_account}${companyName}${this.formatDatePrintBank(ele.วันที่มีผล)}`;
        }

        sumMoney += ele.จำนวนเงิน;

        var rowDetail = "";
        var accCodeDetail = "";
        var moneyDetail = "";
        var dateDetail = this.formatDatePrintBankDetail(ele.วันที่มีผล);

        docDate = this.formatDatePrintBankDetail(ele.วันที่มีผล);
        var nameDetail = ele.ชื่อบัญชี;
        var subDetail = "";
        rowDetail = "D";
        var rowDiff = 6 - (index + 2).toString().length;

        for (var r = 0; r < rowDiff; r++) {
          rowDetail += "0";
        }
        rowDetail += index + 2;

        accCodeDetail = ele.เลขที่บัญชี.toString().replaceAll("-", "");
        console.log(accCodeDetail);

        var moneyDiff =
          10 -
          ele.จำนวนเงิน
            .toFixed(2)
            .toString()
            .replace(".", "").length;
        for (var r = 0; r < moneyDiff; r++) {
          moneyDetail += "0";
        }
        moneyDetail += ele.จำนวนเงิน
          .toFixed(2)
          .toString()
          .replace(".", "");
        console.log(moneyDetail.length);

        if (nameDetail.length <= 35) {
          var diffName = 35 - nameDetail.length;
          for (var r = 0; r < diffName; r++) {
            nameDetail += " ";
          }
        } else {
          var nameDetailsplit = nameDetail.slice(0, 35);
          nameDetail = nameDetailsplit;
        }

        subDetail = rowDetail + "011" + accCodeDetail + "C" + moneyDetail + "089          " + dateDetail + "0000001                                    " + nameDetail + "\r\n";
        console.log(subDetail);
        console.log(subDetail.length);

        textDetail += subDetail;

        if (index == data.length - 1) {
          var rowDiffFoot = 6 - (index + 3).toString().length;
          var rowDetailFoot = "T";
          for (var r = 0; r < rowDiffFoot; r++) {
            rowDetailFoot += "0";
          }
          rowDetailFoot += index + 3;
          var moneyDetailFoot = "";
          var moneyDiffs =
            13 -
            sumMoney
              .toFixed(2)
              .toString()
              .replace(".", "").length;
          for (var r = 0; r < moneyDiffs; r++) {
            moneyDetailFoot += "0";
          }
          moneyDetailFoot += sumMoney
            .toFixed(2)
            .toString()
            .replace(".", "");

          var linediff = 27 - data.length.toString().length;
          var linetotal = "";
          for (var r = 0; r < linediff; r++) {
            linetotal += "0";
          }
          linetotal += data.length;

          textFoot = `${rowDetailFoot}011${this.company_account}${linetotal}${moneyDetailFoot}0000000000000000000000000000000000000000                            `;

          console.log(textFoot);
          console.log(textFoot.length);
        }
      });

      if (textHead.length < 128) {
        var diff = 128 - textHead.length;
        for (var i = 0; i < diff; i++) {
          textHead += " ";
        }
      }

      textHead = textHead + "\r\n";

      element.setAttribute("href", "data:text/plain;charset=Windows-1252," + encodeURIComponent(textHead + textDetail + textFoot));
      element.setAttribute("download", "เอกสารนำส่งธนาคารTTB");

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    formatDatePrintBankDetail(data) {
      let __date = new Date(data);
      let __month = __date.getMonth() + 1;
      let __day = __date.getDate();
      let __year = __date.getFullYear();
      let result = null;

      if (__month.toString().length < 2) {
        __month = "0" + __month;
      }
      if (__day.toString().length < 2) {
        __day = "0" + __day;
      }

      return (result = [__year.toString().substr(-2), __month, __day].join(""));
    },
    formatDatePrintBank(data) {
      let __date = new Date(data);
      let __month = __date.getMonth() + 1;
      let __day = __date.getDate();
      let __year = __date.getFullYear();
      let result = null;

      if (__month.toString().length < 2) {
        __month = "0" + __month;
      }
      if (__day.toString().length < 2) {
        __day = "0" + __day;
      }

      return (result = [__day, __month, __year.toString().substr(-2)].join(""));
    },

    // Start file download.

    downloadexcelbankother() {
      let v = this;
      console.log("this.listpaymenttype: ", this.listpaymenttype);
      console.log("checktypepayment: " + this.checktypepaymentother);
      v.detail_example = [];
      if (this.checktypepaymentother != "") {
        v.dialog_create_other = false;
        var founditem = false;
        for (var key in this.listpaymenttype) {
          console.log(key);
          console.log(v.checktypepaymentother);
          if (v.checktypepaymentother == key) {
            founditem = true;
            if (this.listpaymenttype.hasOwnProperty(key)) {
              if (this.checktypepaymentother == "พร้อมเพย์") {
                this.listpaymenttype[key].forEach((element) => {
                  if (element.paymentType == 1) {
                    v.detail_example.push({
                      ลำดับ: this.index++,
                      ชื่อ: element.name,
                      เลขที่บัญชี: element.promptpayNumber,
                      จำนวนเงิน: element.total_balance,
                    });
                    console.log(key, element);
                  }
                });
                console.log(key, this.listpaymenttype[key]);
                console.log("detail_example", v.detail_example);

                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(v.detail_example, v.head_exampleformbank, v.detail_example, config);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, Example, "เอกสารจ่ายเงินพร้อมเพย์");
                XLSX.writeFile(wb, "เอกสารจ่ายเงินพร้อมเพย์" + this.docno + ".xlsx");
              } else if (this.checktypepaymentother == "เงินสด") {
                this.listpaymenttype[key].forEach((element) => {
                  if (element.paymentType == 2) {
                    v.detail_example.push({
                      ลำดับ: this.index++,
                      ชื่อ: element.name,

                      จำนวนเงิน: element.total_balance,
                    });
                    console.log(key, element);
                  }
                });
                console.log(key, this.listpaymenttype[key]);
                console.log("detail_example", v.detail_example);

                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(v.detail_example, v.head_exampleformbank, v.detail_example, config);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, Example, "เอกสารจ่ายเงินสด");
                XLSX.writeFile(wb, "เอกสารจ่ายเงินสด" + this.docno + ".xlsx");
              } else if (this.checktypepaymentother == "อื่นๆ") {
                this.listpaymenttype[key].forEach((element) => {
                  if (element.paymentType == 3 || (element.paymentType == 0 && element.bankCode == "")) {
                    v.detail_example.push({
                      ลำดับ: this.index++,
                      ชื่อ: element.name,
                      จำนวนเงิน: element.total_balance,
                    });
                    console.log(key, element);
                  }
                });
                console.log(key, this.listpaymenttype[key]);
                console.log("detail_example", v.detail_example);

                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(v.detail_example, v.head_exampleformbank, v.detail_example, config);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, Example, "เอกสารจ่ายเงิน");
                XLSX.writeFile(wb, "เอกสารจ่ายเงิน" + this.docno + ".xlsx");
              }
            }
          }
        }
        if (!founditem) {
          this.snack_model.status = true;
          this.snack_model.msg = "ไม่พบรายการจ่ายเงินท่ีเลือก";
          this.snack_model.type = "error";
        }
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกประเภทการจ่ายเงิน";
        this.snack_model.type = "error";
      }
    },
    downloadexcelbank() {
      let v = this;
      console.log("this.listpaymenttype: ", this.listpaymenttype);
      console.log("checktypepayment: " + this.checktypepayment);
      v.detail_example = [];
      if (this.checktypepayment != "") {
        v.dialog_create = false;
        for (var key in this.listpaymenttype) {
          console.log(key);
          console.log(v.checktypepayment);
          if ("เงินโอน" == key) {
            if (this.listpaymenttype.hasOwnProperty(key)) {
              if (this.checktypepayment == "TTB") {
                this.listpaymenttype[key].forEach((element) => {
                  if (element.bankCode != undefined && element.bankCode != "") {
                    if (element.bankName == "TTB") {
                      v.detail_example.push({
                        ลำดับ: this.index++,
                        ชื่อธนาคาร: element.bankName,
                        ชื่อบัญชี: element.bookName,
                        เลขที่บัญชี: element.bankCode,
                        จำนวนเงิน: element.total_balance,
                        วันที่มีผล: v.form_dialog_create.date,
                      });
                      //console.log(key, element);
                    }
                  }
                });
                console.log(key, this.listpaymenttype[key]);
                console.log("detail_example", v.detail_example);
                v.downloadtext(v.detail_example);
                // var config = { raw: true, type: "string" };
                // var Example = XLSX.utils.json_to_sheet(
                //   v.detail_example,
                //   v.head_exampleformbank,
                //   v.detail_example,
                //   config
                // );
                // var wb = XLSX.utils.book_new();
                // XLSX.utils.book_append_sheet(wb, Example, "เอกสารส่งธนาคาร");
                // XLSX.writeFile(wb, "เอกสารส่งธนาคาร" + ".xlsx");
              } else if (this.checktypepayment == "กรุงไทย") {
                this.listpaymenttype[key].forEach((element) => {
                  if (element.bankCode != undefined && element.bankCode != "") {
                    if (element.bankName == "กรุงไทย") {
                      v.detail_example.push({
                        ลำดับ: this.index++,
                        ชื่อธนาคาร: element.bankName,
                        ชื่อบัญชี: element.bookName,
                        เลขที่บัญชี: element.bankCode,
                        จำนวนเงิน: element.total_balance,
                        วันที่มีผล: v.form_dialog_create.date,
                      });
                      //console.log(key, element);
                    }
                  }
                });
                console.log(key, this.listpaymenttype[key]);
                console.log("detail_example", v.detail_example);

                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(v.detail_example, v.head_exampleformbank, v.detail_example, config);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, Example, "เอกสารส่งธนาคารกรุงไทย");
                XLSX.writeFile(wb, "เอกสารส่งธนาคารกรุงไทย" + ".xlsx");
              }
            }
          }
        }
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกประเภทการจ่ายเงิน";
        this.snack_model.type = "error";
      }
      this.form_dialog_create.date = "";
    },
    setShowDetail(response) {
      //console.log(response);
      let ng = this;
      this.bodyHtml = "";
      this.footerHtml = "";
      this.responvalue = response;
      for (var i = 0; i < response.length; i++) {
        //console.log("response", response[i].processTimes);
        // for (var v = 0; v < response[i].processTimes.length; v++) {
        //   let valueOt = response[i].processTimes[v].ot_rate;
        //   if (typeof this.ot_rate.find((e) => e == valueOt) == "undefined") {
        //     let evObj = valueOt;
        //     if (evObj > 0.0) {
        //       this.ot_rate.push(parseFloat(evObj));
        //     }
        //   }
        //   let valueAbsent = response[i].processTimes[v].deduct_absent_rate;
        //   if (typeof this.absent_rate.find((e) => e == valueAbsent) == "undefined") {
        //     let evObj = valueAbsent;
        //     if (evObj > 0.0) {
        //       this.absent_rate.push(parseFloat(evObj));
        //     }
        //   }
        //   let valueLeave = response[i].processTimes[v].deduct_leave_rate;
        //   if (typeof this.leave_rate.find((e) => e == valueLeave) == "undefined") {
        //     let evObj = valueLeave;

        //     this.leave_rate.push(parseFloat(evObj));
        //   }
        //   let valueOB = response[i].processTimes[v].deduct_ob_rate;
        //   if (typeof this.ob_rate.find((e) => e == valueOB) == "undefined") {
        //     let evObj = valueOB;
        //     if (evObj > 0.0) {
        //       this.ob_rate.push(parseFloat(evObj));
        //     }
        //   }
        //   let valueLate = response[i].processTimes[v].deduct_late_rate;
        //   if (typeof this.late_rate.find((e) => e == valueLate) == "undefined") {
        //     let evObj = valueLate;
        //     if (evObj > 0.0) {
        //       this.late_rate.push(parseFloat(evObj));
        //     }
        //   }
        // }
        for (var x = 0; x < response[i].incomeAndExpenses.length; x++) {
          let name = response[i].incomeAndExpenses[x].name;
          let flag = response[i].incomeAndExpenses[x].tranFlag;
          if (flag == 0) {
            // if (typeof this.headReceive.find((e) => e == name) == "undefined") {
            //   let evObj = name;
            //   this.headReceive.push(evObj);
            // }
          } else {
            if (typeof this.headExpenses.find((e) => e == name) == "undefined") {
              let evObj = name;
              this.headExpenses.push(evObj);
            }
          }
        }
      }

      this.ot_rate = this.ot_rate.sort(function(a, b) {
        return a - b;
      });
      this.absent_rate = this.absent_rate.sort(function(a, b) {
        return a - b;
      });
      this.leave_rate = this.leave_rate.sort(function(a, b) {
        return a - b;
      });
      this.late_rate = this.late_rate.sort(function(a, b) {
        return a - b;
      });
      this.ob_rate = this.ob_rate.sort(function(a, b) {
        return a - b;
      });

      this.renderheader();

      response
        .sort(function(a, b) {
          a.code.localeCompare(b.code);
        })
        .sort(function(a, b) {
          a.department_name.localeCompare(b.department_name);
        });
      let retData = ng.groupBy(response, "department_name");
      let lastRowSummary = {
        salary: 0.0,
        craftAmount: 0.0,
        positionAmount: 0.0,
        incomeBeforeExtraAndOT: 0.0,
        perDay: 0.0,
        perHour: 0.0,
        extraAmount: 0.0,
        extraHoliday: 0.0,
        extraHolidayAmount: 0.0,
        OT: 0.0,
        OTAmount: 0.0,
        totalAddIncome: 0.0,
        totalCommission: 0.0,
        incomeBeforeExpenses: 0.0,
        leave: 0.0,
        leaveUncut: 0.0,
        leaveAmount: 0.0,
        leaveEvent: 0.0,
        leaveAmountEvent: 0.0,
        absent: 0.0,
        absentAmount: 0.0,
        absentEvent: 0.0,
        absentAmountEvent: 0.0,
        totalLate: 0.0,
        lateAmount: 0.0,
        totalOB: 0.0,
        outBeforTimeAmount: 0.0,
        insuranceAmount: 0.0,
        vatAmount: 0.0,
        notCheckInAmount: 0.0,
        employeeShirtAmount: 0.0,
        advanceAmount: 0.0,
        totalAddExpenses: 0.0,
        advancePayment: 0.0,
        deductAmount: 0.0,
        balanceAmount: 0.0,
        salaryTax: 0.0,
      };
      var lastSummaryOT = [];
      var lastSummaryOTInc = [];
      var lastSummaryLeave = [];
      var lastSummaryLeaveInc = [];
      var lastSummaryAbsent = [];
      var lastSummaryAbsentInc = [];
      var lastSummaryOb = [];
      var lastSummaryObInc = [];
      var lastSummaryLate = [];
      var lastSummaryLateInc = [];
      var lastSummaryTaxlevel = [];
      var lastSummaryReceive = [];
      var lastSummaryVat = [];
      var lastSummaryExpenses = [];
      for (let item in retData) {
        let departmentHtml = "";
        let rowHtml = "";
        let footerDepartmentHtml = "";
        let departName = item.toString() == "" ? "" : item.toString();
        departmentHtml += this.renderDepartment(departName, ng.ot_rate, ng.absent_rate, ng.leave_rate, ng.ob_rate, ng.late_rate, response, ng.headReceive, ng.headExpenses);
        var groupSummaryReceive = [];
        var groupSummaryVat = [];
        var groupSummaryExpenses = [];
        var groupSummaryOT = [];
        var groupSummaryOTInc = [];
        var groupSummaryLeave = [];
        var groupSummaryLeaveInc = [];
        var groupSummaryAbsent = [];
        var groupSummaryAbsentInc = [];
        var groupSummaryOb = [];
        var groupSummaryObInc = [];
        var groupSummaryLate = [];
        var groupSummaryLateInc = [];
        var groupSummaryTaxlevel = [];
        let groupSummary = {
          salary: 0.0,
          craftAmount: 0.0,
          positionAmount: 0.0,
          incomeBeforeExtraAndOT: 0.0,
          perDay: 0.0,
          perHour: 0.0,
          extraAmount: 0.0,
          extraHoliday: 0.0,
          extraHolidayAmount: 0.0,
          totalCommission: 0.0,
          OT: 0.0,
          OTAmount: 0.0,
          totalAddIncome: 0.0,
          incomeBeforeExpenses: 0.0,
          leave: 0.0,
          leaveUncut: 0.0,
          leaveAmount: 0.0,
          leaveEvent: 0.0,
          leaveAmountEvent: 0.0,
          absent: 0.0,
          absentAmount: 0.0,
          absentEvent: 0.0,
          absentAmountEvent: 0.0,
          totalLate: 0.0,
          lateAmount: 0.0,
          totalOB: 0.0,
          outBeforTimeAmount: 0.0,
          insuranceAmount: 0.0,
          vatAmount: 0.0,
          notCheckInAmount: 0.0,
          employeeShirtAmount: 0.0,
          advanceAmount: 0.0,
          totalAddExpenses: 0.0,
          advancePayment: 0.0,
          deductAmount: 0.0,
          balanceAmount: 0.0,
          salaryTax: 0.0,
        };

        retData[item].forEach(function(employee, i) {
          if (
            (employee.isResign == false && employee.totalWorkDay == 0 && employee.isSpecial == true) ||
            (employee.isResign == true && employee.totalWorkDay > 0) ||
            (employee.isResign == false && employee.totalWorkDay > 0)
          ) {
            let craftAmount = 0;
            let positionAmount = 0;
            let extraAmount = 0;
            let insuranceAmount = 0;
            let vatAmount = 0;
            let advancePayment = 0;
            craftAmount += employee.incomeCraft;
            positionAmount += employee.incomePosition;
            extraAmount += employee.incomeSpecial;
            insuranceAmount += employee.deductSS;

            vatAmount = employee.deduct_tax;
            rowHtml += ng.renderNormalRow(
              employee,
              craftAmount,
              positionAmount,
              extraAmount,
              insuranceAmount,
              vatAmount,
              advancePayment,
              ng.ot_rate,
              ng.absent_rate,
              ng.leave_rate,
              ng.ob_rate,
              ng.late_rate,
              ng.headReceive,
              ng.headVat,
              ng.headExpenses,
              i
            );

            groupSummary.salary += employee.salary;
            groupSummary.craftAmount += craftAmount;
            groupSummary.positionAmount += positionAmount;
            groupSummary.salaryTax += employee.salaryTax;

            if (employee.empType == 1) {
              if (employee.perDay > 0) {
                groupSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay + craftAmount + positionAmount;
              } else {
                groupSummary.incomeBeforeExtraAndOT += employee.totalByDayEarning;
              }
            } else if (employee.empType == 2) {
              if (employee.perHour > 0) {
                groupSummary.incomeBeforeExtraAndOT += employee.perHour * employee.totalWorkhour + craftAmount + positionAmount;
              } else {
                groupSummary.incomeBeforeExtraAndOT += employee.totalEarningTypeHours;
              }
            } else {
              if (employee.isResign || employee.isNewbie) {
                groupSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay;
              } else {
                groupSummary.incomeBeforeExtraAndOT += employee.salary + craftAmount + positionAmount;
              }
            }

            groupSummary.perDay += employee.perDay;
            groupSummary.perHour += employee.perHour;
            groupSummary.extraAmount += extraAmount;
            groupSummary.totalCommission += employee.total_commission;
            groupSummary.extraHoliday += employee.holidaywork;
            groupSummary.extraHolidayAmount += employee.holidayworkearning;
            groupSummary.OT += employee.totalOT;

            for (var y = 0; y < ng.headReceive.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headReceive[y].name && c.branchPay == ng.headReceive[y].code && c.tranFlag == 0);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }
              if (groupSummaryReceive.length == ng.headReceive.length) {
                groupSummaryReceive[y] = groupSummaryReceive[y] + value;
              } else {
                groupSummaryReceive.push(value);
              }
            }

            for (var y = 0; y < ng.headVat.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[y].code && c.tranFlag == 0 && c.notCalTax == "0");
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              var incomeTax = 0;
              incomeTax = employee.incomeTax;

              if (groupSummaryVat.length == ng.headVat.length) {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                groupSummaryVat[y] = groupSummaryVat[y] + val;
              } else {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                groupSummaryVat.push(val);
              }
            }

            for (var y = 0; y < ng.headExpenses.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headExpenses[y] && c.tranFlag == 1);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }
              if (groupSummaryExpenses.length == ng.headExpenses.length) {
                groupSummaryExpenses[y] = groupSummaryExpenses[y] + value;
              } else {
                groupSummaryExpenses.push(value);
              }
            }
            for (var y = 0; y < ng.ot_rate.length; y++) {
              var value = 0;
              var ottime = 0;
              let rowz = employee.processTimes.filter((c) => c.ot_rate == ng.ot_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].ot_by_date);
                ottime += parseFloat(rowz[v].total_ottime);
              }

              if (groupSummaryOT.length == ng.ot_rate.length) {
                groupSummaryOT[y] = groupSummaryOT[y] + ottime;
                groupSummaryOTInc[y] = groupSummaryOTInc[y] + value;
              } else {
                groupSummaryOT.push(ottime);
                groupSummaryOTInc.push(value);
              }
            }
            for (var y = 0; y < ng.leave_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_leave_rate == ng.leave_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.leave_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].deduct_leave_by_date);
                time += parseFloat(rowz[v].total_leavetime);
              }

              if (groupSummaryLeave.length == ng.leave_rate.length) {
                groupSummaryLeave[y] = groupSummaryLeave[y] + time;
                groupSummaryLeaveInc[y] = groupSummaryLeaveInc[y] + value;
              } else {
                groupSummaryLeave.push(time);
                groupSummaryLeaveInc.push(value);
              }
            }
            for (var y = 0; y < ng.absent_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_absent_rate == ng.absent_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_absent_by_date);
                time += parseFloat(rowz[v].total_absenttime);
              }

              if (groupSummaryAbsent.length == ng.absent_rate.length) {
                groupSummaryAbsent[y] = groupSummaryAbsent[y] + time;
                groupSummaryAbsentInc[y] = groupSummaryAbsentInc[y] + value;
              } else {
                groupSummaryAbsent.push(time);
                groupSummaryAbsentInc.push(value);
              }
            }
            for (var y = 0; y < ng.late_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_late_rate == ng.late_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_late_by_date);
                time += parseFloat(rowz[v].total_latetime);
              }

              if (groupSummaryLate.length == ng.late_rate.length) {
                groupSummaryLate[y] = groupSummaryLate[y] + time;
                groupSummaryLateInc[y] = groupSummaryLateInc[y] + value;
              } else {
                groupSummaryLate.push(time);
                groupSummaryLateInc.push(value);
              }
            }
            for (var y = 0; y < ng.ob_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_ob_rate == ng.ob_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_ob_by_date);
                time += parseFloat(rowz[v].total_out_before_time);
              }

              if (groupSummaryOb.length == ng.ob_rate.length) {
                groupSummaryOb[y] = groupSummaryOb[y] + time;
                groupSummaryObInc[y] = groupSummaryObInc[y] + value;
              } else {
                groupSummaryOb.push(time);
                groupSummaryObInc.push(value);
              }
            }

            /* for (var k = 0; k < employee.taxLevels.length; k++) {
                             if (groupSummaryTaxlevel.length == employee.taxLevels.length) {
                                 groupSummaryTaxlevel[k] = groupSummaryTaxlevel[k] + parseFloat(employee.taxLevels[k].net);
                             } else {
                                 groupSummaryTaxlevel.push(parseFloat(employee.taxLevels[k].net))
                             }


                         }*/
            //console.log(groupSummaryTaxlevel)
            //console.log(groupSummaryOTInc)
            groupSummary.OTAmount += employee.otEarning;

            groupSummary.totalAddIncome += employee.totalAddIncome;
            groupSummary.incomeBeforeExpenses += employee.totalEarning;
            groupSummary.leave += employee.totalLeave;
            groupSummary.leaveUncut += employee.totalLeaveUncut;
            groupSummary.leaveAmount += employee.deductLeave;
            groupSummary.leaveEvent += employee.totalLeaveEvent;
            groupSummary.leaveAmountEvent += employee.deductLeaveEvent;
            groupSummary.absent += employee.totalAbsent;
            groupSummary.absentAmount += employee.deductAbsent;
            groupSummary.absentEvent += employee.totalAbsentEvent;
            groupSummary.absentAmountEvent += employee.deductAbsentEvent;

            groupSummary.lateAmount += employee.deductLate;
            groupSummary.totalLate += employee.totalLate;
            groupSummary.totalOB += employee.totalOutbefore;
            groupSummary.outBeforTimeAmount += employee.deductOutbefore;
            groupSummary.insuranceAmount += insuranceAmount;
            groupSummary.vatAmount += vatAmount;
            groupSummary.notCheckInAmount = 0.0;
            groupSummary.employeeShirtAmount = 0.0;
            groupSummary.advanceAmount = 0.0;
            groupSummary.totalAddExpenses += employee.totalAddExpenses;
            groupSummary.advancePayment += advancePayment;
            groupSummary.deductAmount += employee.totalDeduct;
            groupSummary.balanceAmount += employee.total_balance;

            // for (var y = 0; y < ng.headReceive.length; y++) {
            //   var value = 0;
            //   let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headReceive[y].name && c.branchPay == ng.headReceive[y].code && c.tranFlag == 0);
            //   for (var v = 0; v < rowz.length; v++) {
            //     //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
            //     value += parseFloat(rowz[v].amount);
            //   }
            //   console.log(groupSummary.vatAmount, value, groupSummary.totalAddIncome);
            //   if (groupSummaryVat.length == ng.headReceive.length) {
            //     let val = (groupSummary.vatAmount * value) / groupSummary.totalAddIncome;
            //     if (isNaN(val)) {
            //       val = 0;
            //     }

            //     groupSummaryVat[y] = groupSummaryVat[y] + val;

            //     console.log("groupSummaryVat", groupSummaryVat);
            //   } else {
            //     let val = (groupSummary.vatAmount * value) / groupSummary.totalAddIncome;
            //     if (isNaN(val)) {
            //       val = 0;
            //     }
            //     groupSummaryVat.push(val);
            //   }
            // }

            //create json for export excle //
            lastRowSummary.salary += employee.salary;
            lastRowSummary.craftAmount += craftAmount;
            lastRowSummary.positionAmount += positionAmount;
            lastRowSummary.salaryTax += employee.salaryTax;

            if (employee.empType == 1) {
              if (employee.perDay > 0) {
                lastRowSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay + craftAmount + positionAmount;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT += employee.totalByDayEarning;
              }
            } else if (employee.empType == 2) {
              if (employee.perHour > 0) {
                lastRowSummary.incomeBeforeExtraAndOT += employee.perHour * employee.totalWorkhour + craftAmount + positionAmount;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT += employee.totalEarningTypeHours;
              }
            } else {
              if (employee.isResign || employee.isNewbie) {
                lastRowSummary.incomeBeforeExtraAndOT += employee.perDay * employee.totalWorkDay;
              } else {
                lastRowSummary.incomeBeforeExtraAndOT += employee.salary + craftAmount + positionAmount;
              }
            }

            lastRowSummary.perDay += employee.perDay;
            lastRowSummary.perHour += employee.perHour;
            lastRowSummary.extraAmount += extraAmount;
            lastRowSummary.totalCommission += employee.total_commission;
            lastRowSummary.extraHoliday += employee.holidaywork;
            lastRowSummary.extraHolidayAmount += employee.holidayworkearning;

            for (var y = 0; y < ng.headReceive.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headReceive[y].name && c.branchPay == ng.headReceive[y].code && c.tranFlag == 0);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              if (lastSummaryReceive.length == ng.headReceive.length) {
                lastSummaryReceive[y] = lastSummaryReceive[y] + value;
              } else {
                lastSummaryReceive.push(value);
              }
            }

            for (var y = 0; y < ng.headVat.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[y].code && c.tranFlag == 0 && c.notCalTax == "0");
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              var incomeTax = 0;
              incomeTax = employee.processTaxDetail.incomeTax;
              if (lastSummaryVat.length == ng.headVat.length) {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                lastSummaryVat[y] = lastSummaryVat[y] + val;
              } else {
                var val = (incomeTax * value) / (employee.totalAddIncome - employee.totalAddIncomeExceptTax);
                if (isNaN(val)) {
                  val = 0;
                }
                lastSummaryVat.push(val);
              }
            }

            for (var y = 0; y < ng.headExpenses.length; y++) {
              var value = 0;
              let rowz = employee.incomeAndExpenses.filter((c) => c.name == ng.headExpenses[y] && c.tranFlag == 1);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].amount);
              }

              if (lastSummaryExpenses.length == ng.headExpenses.length) {
                lastSummaryExpenses[y] = lastSummaryExpenses[y] + value;
              } else {
                lastSummaryExpenses.push(value);
              }
            }
            for (var y = 0; y < ng.ot_rate.length; y++) {
              var value = 0;
              var ottime = 0;
              let rowz = employee.processTimes.filter((c) => c.ot_rate == ng.ot_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.ot_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].ot_by_date);
                ottime += parseFloat(rowz[v].total_ottime);
              }

              if (lastSummaryOT.length == ng.ot_rate.length) {
                lastSummaryOT[y] = lastSummaryOT[y] + ottime;
                lastSummaryOTInc[y] = lastSummaryOTInc[y] + value;
              } else {
                lastSummaryOT.push(ottime);
                lastSummaryOTInc.push(value);
              }
            }
            for (var y = 0; y < ng.leave_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_leave_rate == ng.leave_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                //  console.log(ng.leave_rate[y] + " : " + parseFloat(rowz[v].ot_by_date))
                value += parseFloat(rowz[v].deduct_leave_by_date);
                time += parseFloat(rowz[v].total_leavetime);
              }

              if (lastSummaryLeave.length == ng.leave_rate.length) {
                lastSummaryLeave[y] = lastSummaryLeave[y] + time;
                lastSummaryLeaveInc[y] = lastSummaryLeaveInc[y] + value;
              } else {
                lastSummaryLeave.push(time);
                lastSummaryLeaveInc.push(value);
              }
            }
            for (var y = 0; y < ng.absent_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_absent_rate == ng.absent_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_absent_by_date);
                time += parseFloat(rowz[v].total_absenttime);
              }

              if (lastSummaryAbsent.length == ng.absent_rate.length) {
                lastSummaryAbsent[y] = lastSummaryAbsent[y] + time;
                lastSummaryAbsentInc[y] = lastSummaryAbsentInc[y] + value;
              } else {
                lastSummaryAbsent.push(time);
                lastSummaryAbsentInc.push(value);
              }
            }
            for (var y = 0; y < ng.late_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_late_rate == ng.late_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_late_by_date);
                time += parseFloat(rowz[v].total_latetime);
              }

              if (lastSummaryLate.length == ng.late_rate.length) {
                lastSummaryLate[y] = lastSummaryLate[y] + time;
                lastSummaryLateInc[y] = lastSummaryLateInc[y] + value;
              } else {
                lastSummaryLate.push(time);
                lastSummaryLateInc.push(value);
              }
            }
            for (var y = 0; y < ng.ob_rate.length; y++) {
              var value = 0;
              var time = 0;
              let rowz = employee.processTimes.filter((c) => c.deduct_ob_rate == ng.ob_rate[y]);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].deduct_ob_by_date);
                time += parseFloat(rowz[v].total_out_before_time);
              }

              if (lastSummaryOb.length == ng.ob_rate.length) {
                lastSummaryOb[y] = lastSummaryOb[y] + time;
                lastSummaryObInc[y] = lastSummaryObInc[y] + value;
              } else {
                lastSummaryOb.push(time);
                lastSummaryObInc.push(value);
              }
            }
            /* for (var k = 0; k < employee.taxLevels.length; k++) {
                             if (lastSummaryTaxlevel.length == employee.taxLevels.length) {
                                 lastSummaryTaxlevel[k] = lastSummaryTaxlevel[k] + parseFloat(employee.taxLevels[k].net);
                             } else {
                                 lastSummaryTaxlevel.push(parseFloat(employee.taxLevels[k].net));
                             }


                         }*/
            //console.log(lastSummaryOT)
            //console.log(lastSummaryOTInc)
            lastRowSummary.OT += employee.totalOT;
            lastRowSummary.OTAmount += employee.otEarning;
            lastRowSummary.totalAddIncome += employee.totalAddIncome;
            lastRowSummary.incomeBeforeExpenses += employee.totalEarning;
            lastRowSummary.leave += employee.totalLeave;
            lastRowSummary.leaveUncut += employee.totalLeaveUncut;
            lastRowSummary.leaveAmount += employee.deductLeave;
            lastRowSummary.leaveEvent += employee.totalLeaveEvent;
            lastRowSummary.leaveAmountEvent += employee.deductLeaveEvent;
            lastRowSummary.absent += employee.totalAbsent;
            lastRowSummary.absentAmount += employee.deductAbsent;
            lastRowSummary.absentEvent += employee.totalAbsentEvent;
            lastRowSummary.absentAmountEvent += employee.deductAbsentEvent;
            lastRowSummary.lateAmount += employee.deductLate;
            lastRowSummary.totalLate += employee.totalLate;
            lastRowSummary.totalOB += employee.totalOutbefore;
            lastRowSummary.outBeforTimeAmount += employee.deductOutbefore;
            lastRowSummary.insuranceAmount += insuranceAmount;
            lastRowSummary.vatAmount += vatAmount;
            lastRowSummary.notCheckInAmount = 0.0;
            lastRowSummary.employeeShirtAmount = 0.0;
            lastRowSummary.advanceAmount = 0.0;
            lastRowSummary.totalAddExpenses += employee.totalAddExpenses;
            lastRowSummary.advancePayment += advancePayment;
            lastRowSummary.deductAmount += employee.totalDeduct;
            lastRowSummary.balanceAmount += employee.total_balance;
          }
        });

        footerDepartmentHtml = ng.renderGroupFooter(
          groupSummaryReceive,
          groupSummaryExpenses,
          groupSummaryTaxlevel,
          groupSummary,
          groupSummaryOTInc,
          groupSummaryOT,
          groupSummaryAbsent,
          groupSummaryAbsentInc,
          groupSummaryLeave,
          groupSummaryLeaveInc,
          groupSummaryLate,
          groupSummaryLateInc,
          groupSummaryOb,
          groupSummaryObInc,
          ng.ot_rate,
          ng.leave_rate,
          ng.absent_rate,
          ng.late_rate,
          ng.ob_rate,
          false,
          ng.headReceive,
          ng.headVat,
          ng.headExpenses,
          groupSummaryVat
        );

        ng.bodyHtml += departmentHtml + rowHtml + footerDepartmentHtml;
      }

      var footerHtmlx = ng.renderGroupFooter(
        lastSummaryReceive,
        lastSummaryExpenses,
        lastSummaryTaxlevel,
        lastRowSummary,
        lastSummaryOTInc,
        lastSummaryOT,
        lastSummaryAbsent,
        lastSummaryAbsentInc,
        lastSummaryLeave,
        lastSummaryLeaveInc,
        lastSummaryLate,
        lastSummaryLateInc,
        lastSummaryOb,
        lastSummaryObInc,
        ng.ot_rate,
        ng.leave_rate,
        ng.absent_rate,
        ng.late_rate,
        ng.ob_rate,
        true,
        ng.headReceive,
        ng.headVat,
        ng.headExpenses,
        lastSummaryVat
      );

      ng.bodyHtml += footerHtmlx;

      this.showbodyhtml = this.bodyHtml;
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    renderNormalRow(
      item,
      craftAmount,
      positionAmount,
      extraAmount,
      insuranceAmount,
      vatAmount,
      advancePayment,
      ot_rate,
      absent_rate,
      leave_rate,
      ob_rate,
      late_rate,
      headReceive,
      headVat,
      headExpenses,
      idx
    ) {
      let empTypeText = "";
      let ng = this;
      if (
        (item.isResign == false && item.totalWorkDay == 0 && item.isSpecial == true) ||
        (item.isResign == true && item.totalWorkDay > 0) ||
        (item.isResign == false && item.totalWorkDay > 0)
      ) {
        //console.log(item.code)
        switch (item.empType) {
          case 0:
            empTypeText = "รายเดือน";
            break;
          case 1:
            empTypeText = "รายวัน";
            break;
          case 2:
            empTypeText = "รายชั่วโมง";
            break;
          default:
            break;
        }
        let htmlz =
          `<tr>` +
          `<td nowrap ><input class="checkit" type="checkbox" value="` +
          item.code +
          `">` +
          `<td nowrap>${idx + 1}</td>` +
          `<td nowrap>` +
          item.code +
          `</td>` +
          `<td nowrap>` + (item.nameTitle || '') + `</td>` +
          `<td nowrap>` + (item.firstName || '') + `</td>` +
          `<td nowrap>` + (item.lastName || '') + `</td>` +
          (this.table_head_model.ประเภท == "1" ? `<td nowrap>` + empTypeText + `</td>` : "") +
          (this.table_head_model.ตำแหน่ง == "1" ? `<td nowrap>` + item.position + `</td>` : "");
        if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
          if (item.empType == 0) {
            if (item.isResign || item.isNewbie) {
              htmlz += `<td nowrap>` + item.totalWorkDay + `</td>`;
            } else {
              htmlz += `<td nowrap>` + item.workingDate + `</td>`;
            }
          } else if (item.empType == 2) {
            htmlz += `<td nowrap>` + item.totalWorkhour + ` ชม</td>`;
          } else {
            htmlz += `<td nowrap>` + item.totalWorkDay + `</td>`;
          }
        }

        htmlz +=
          `<td nowrap>` +
          this.getBranchName(item.branch) +
          `</td>` +
          (this.table_head_model.เงินเดือน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(item.salary) + `</td>` : "") +
          (this.table_head_model.ค่าฝีมือ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(craftAmount) + `</td>` : "") +
          (this.table_head_model.ค่าตำแหน่ง == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(positionAmount) + `</td>` : "");
        if (this.table_head_model.รวมเงินได้ == "1") {
          if (item.empType == 1) {
            if (item.perDay > 0) {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.perDay * item.totalWorkDay + craftAmount + positionAmount) + `</td>`;
            } else {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.totalByDayEarning) + `</td>`;
            }
          } else if (item.empType == 2) {
            if (item.perHour > 0) {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.perHour * item.totalWorkhour + craftAmount + positionAmount) + `</td>`;
            } else {
              htmlz +=
                `<td nowrap style="text-align:right;background-color: #B2FF59">` +
                ng.thousandSep(item.totalEarningTypeHours) +
                ` <span class='fa fa-search earningdetail' role='button' code='` +
                item.code +
                `'></span></td>`;
            }
          } else {
            if (item.isResign || item.isNewbie) {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.perDay * item.totalWorkDay) + `</td>`;
            } else {
              htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.salary + craftAmount + positionAmount) + `</td>`;
            }
          }
        }

        htmlz += this.table_head_model.วันละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(item.perDay) + `</td>` : "";
        htmlz += this.table_head_model.ชั่วโมงละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(item.perHour) + `</td>` : "";

        for (var i = 0; i < ot_rate.length; i++) {
          var value = 0;
          var ottime = 0;
          let rowz = item.processTimes.filter((c) => c.ot_rate == ot_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            value += parseFloat(rowz[v].ot_by_date);
            ottime += parseFloat(rowz[v].total_ottime);
          }
          htmlz += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(ottime) + `</td>` : "";
          htmlz += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(value) + `</td>` : "";
        }

        htmlz +=
          this.table_head_model.ชม_OT_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #81D4FA">` + ng.thousandSep(item.totalOT) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.เงิน_OT_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #81D4FA">` + ng.thousandSep(item.otEarning) + `</td>`
            : "";

        if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
          if (this.table_head_model.รายละเอียดรายรับ == "1") {
            for (let i = 0; i < headReceive.length; i++) {
              let value = 0;
              let rowz = item.incomeAndExpenses.filter((c) => c.name == ng.headReceive[i].name && c.branchPay == ng.headReceive[i].code && c.tranFlag == 0);
              for (let v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].amount);
              }
              htmlz += `<td nowrap class="subDetail" style="text-align:right;background-color:#D1C4E9" >` + ng.thousandSep(value) + `</td>`;
            }
          }
          // htmlz += `<td nowrap style="text-align:right;background-color:#D1C4E9">` + ng.thousandSep(item.totalAddIncome) + `</td>`;
        }
        htmlz +=
          this.table_head_model.เบี้ยขยัน == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #80DEEA">` + item.total_commission + `</td>`
            : "";
        htmlz += this.table_head_model.วันหยุดพิเศษ == "1" ? `<td nowrap style="text-align:right;background-color: #B9F6CA">` + item.holidaywork + `</td>` : "";
        htmlz +=
          this.table_head_model.รายได้วันหยุดพิเศษ == "1"
            ? `<td nowrap style="text-align:right;background-color: #B9F6CA">` + ng.thousandSep(item.holidayworkearning) + `</td>`
            : "";
        htmlz += this.table_head_model.รวมรายได้ == "1" ? `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.totalEarning) + `</td>` : "";

        for (var i = 0; i < leave_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_leave_rate == leave_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(leave_rate[i] + " : " + parseFloat(rowz[v].deduct_leave_by_date))
            value += parseFloat(rowz[v].deduct_leave_by_date);
            time += parseFloat(rowz[v].total_leavetime);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }

        htmlz +=
          this.table_head_model.ชม_ลา_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #FFB74D">` + ng.thousandSep(item.totalLeave) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินลา_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #FFB74D">` + ng.thousandSep(item.deductLeave) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.ลาไม่หักเงิน == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #FFF">` + ng.thousandSep(item.totalLeaveUncut) + `</td>`
            : "";

        for (var i = 0; i < absent_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_absent_rate == absent_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_absent_by_date);
            time += parseFloat(rowz[v].total_absenttime);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }
        htmlz +=
          this.table_head_model.ชม_ขาด_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #EF5350">` + ng.thousandSep(item.totalAbsent) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินขาด_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #EF5350">` + ng.thousandSep(item.deductAbsent) + `</td>`
            : "";

        for (var i = 0; i < late_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_late_rate == late_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_late_by_date);
            time += parseFloat(rowz[v].total_latetime);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }
        htmlz +=
          this.table_head_model.สาย_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #A7FFEB">` + ng.thousandSep(item.totalLate) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักเงินสาย_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #A7FFEB">` + ng.thousandSep(item.deductLate) + `</td>`
            : "";

        for (var i = 0; i < ob_rate.length; i++) {
          var value = 0;
          var time = 0;
          let rowz = item.processTimes.filter((c) => c.deduct_ob_rate == ob_rate[i]);
          for (var v = 0; v < rowz.length; v++) {
            //console.log(ot_rate[i] + " : " + parseFloat(rowz[v].ot_by_date))
            value += parseFloat(rowz[v].deduct_ob_by_date);
            time += parseFloat(rowz[v].total_out_before_time);
          }
          //console.log(value)

          htmlz +=
            this.table_head_model.เวลาเข้างาน == "1"
              ? `<td nowrap style="text-align:right;">` +
                ng.thousandSep(time) +
                `</td>
            <td nowrap style="text-align:right;">` +
                ng.thousandSep(value) +
                `</td>`
              : "";
        }
        htmlz +=
          this.table_head_model.ออกก่อน_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #E6EE9C">` + ng.thousandSep(item.totalOutbefore) + `</td>`
            : "";
        htmlz +=
          this.table_head_model.หักออกก่อน_รวม == "1" && localStorage._is_timeattendance == 1
            ? `<td nowrap style="text-align:right;background-color: #E6EE9C">` + ng.thousandSep(item.deductOutbefore) + `</td>`
            : "";
        htmlz += this.table_head_model.ประกันสังคม == "1" ? `<td nowrap style="text-align:right;background-color: #FFF">` + ng.thousandSep(insuranceAmount) + `</td>` : "";

        htmlz += `<td nowrap style="text-align:right;">` + ng.thousandSep(item.salaryTax) + `</td>`;
        for (var i = 0; i < headVat.length; i++) {
          let value = 0;
          let rowz = item.incomeAndExpenses.filter((c) => c.branchPay == ng.headVat[i].code && c.tranFlag == 0 && c.notCalTax == "0");
          for (let v = 0; v < rowz.length; v++) {
            value += parseFloat(rowz[v].amount);
          }
          var incomeTax = 0;
          incomeTax = item.incomeTax;
          if (incomeTax > 0) {
            var val = (incomeTax * value) / (item.totalAddIncome - item.totalAddIncomeExceptTax);
            if (isNaN(val)) {
              val = 0;
            }

            htmlz += `<td nowrap class="" style="text-align:right; background-color:#D1C4E9" >` + ng.thousandSep(val) + `</td>`;
          } else {
            var val = 0;

            htmlz += `<td nowrap style="text-align:right;background-color:#D1C4E9 " class="">` + ng.thousandSep(val) + `</td>`;
          }
        }
        if (this.table_head_model.ภาษี == "1") {
          htmlz += `<td nowrap style="text-align:right;">` + ng.thousandSep(vatAmount) + `</td>`;
        }

        if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
          if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
            for (var i = 0; i < headExpenses.length; i++) {
              var value = 0;

              let rowz = item.incomeAndExpenses.filter((c) => c.name == headExpenses[i] && c.tranFlag == 1);
              for (var v = 0; v < rowz.length; v++) {
                value += parseFloat(rowz[v].amount);
              }

              htmlz +=
                `
            <td nowrap style="text-align:right;background-color:#FFCCBC" class="subDetail">` +
                ng.thousandSep(value) +
                `</td>`;
            }
          }
          htmlz += `<td nowrap style="text-align:right;background-color: #FFCCBC">` + ng.thousandSep(item.totalAddExpenses) + `</td>`;
        }

        htmlz += this.table_head_model.รวมหัก == "1" ? `<td nowrap style="text-align:right;background-color: #FFAB91">` + ng.thousandSep(item.totalDeduct) + `</td>` : "";

        if (this.table_head_model.คงเหลือเงิน == "1") {
          if (item.totalBalance < 0) {
            htmlz += `<td nowrap style="text-align:right;">0.0</td>`;
          } else {
            htmlz += `<td nowrap style="text-align:right;background-color: #B2FF59">` + ng.thousandSep(item.total_balance) + `</td>`;
          }
        }

        if (this.table_head_model.ประเภทการจ่ายเงิน == "1" && this.table_head_model.เลขที่บัญชี == "1") {
          if (item.paymentType == 0 && item.bankCode != "") {
            htmlz += `<td nowrap style="text-align:left;">` + item.bankName + `</td>`;
            htmlz += `<td nowrap style="text-align:left;">` + item.bankCode + `</td>`;
          } else if (item.paymentType == 1) {
            htmlz += `<td nowrap style="text-align:left;">พร้อมเพย์</td>`;
            htmlz += `<td nowrap style="text-align:left;">` + item.promptpayNumber + `</td>`;
          } else if (item.paymentType == 2) {
            htmlz += `<td nowrap style="text-align:left;">เงินสด</td>`;
            htmlz += `<td nowrap style="text-align:left;"></td>`;
          } else {
            htmlz += `<td nowrap style="text-align:left;">อื่นๆ</td>`;
            htmlz += `<td nowrap style="text-align:left;"></td>`;
          }
        }

        htmlz += `</tr>`;

        return htmlz;
      }
    },
    renderGroupFooter(
      groupSummaryReceive,
      groupSummaryExpenses,
      groupSummaryTaxlevel,
      groupSummary,
      groupSummaryOTInc,
      groupSummaryOT,
      groupSummaryAbsent,
      groupSummaryAbsentInc,
      groupSummaryLeave,
      groupSummaryLeaveInc,
      groupSummaryLate,
      groupSummaryLateInc,
      groupSummaryOb,
      groupSummaryObInc,
      ot_rate,
      leave_rate,
      absent_rate,
      late_rate,
      ob_rate,
      isLastRow,
      headReceive,
      headVat,
      headExpenses,
      groupSummaryVat
    ) {
      //console.log("groupSummaryVat", groupSummaryVat);
      var html = "";
      let ng = this;
      html += `<tr style="background-color:` + (isLastRow ? "#5AC594" : "#dff0d8") + `">`;
      if (isLastRow) {
        html += `<td nowrap  colspan='7'>รวมทั้งหมด</td>`;
      } else {
        html += `<td nowrap colspan='7'>รวม</td>`;
      }

      html += this.table_head_model.เงินเดือน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.salary) + `</td>` : "";
      html += this.table_head_model.ค่าฝีมือ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.craftAmount) + `</td>` : "";
      html += this.table_head_model.ค่าตำแหน่ง == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.positionAmount) + `</td>` : "";
      html += this.table_head_model.รวมเงินได้ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.incomeBeforeExtraAndOT) + `</td>` : "";
      html += this.table_head_model.วันละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.perDay) + `</td>` : "";
      html += this.table_head_model.ชั่วโมงละ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.perHour) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < ot_rate.length; s++) {
          html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryOT[s]) + `</td>`;
          html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryOTInc[s]) + `</td>`;
        }
      }
      html +=
        this.table_head_model.ชม_OT_รวม == "1" && localStorage._is_timeattendance == 1 ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.OT) + `</td>` : "";
      html +=
        this.table_head_model.เงิน_OT_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.OTAmount) + `</td>`
          : "";

      if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
        if (this.table_head_model.รายละเอียดรายรับ) {
          for (var s = 0; s < headReceive.length; s++) {
            html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(groupSummaryReceive[s]) + `</td>`;
          }
        }
        // html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalAddIncome) + `</td>`;
      }
      html +=
        this.table_head_model.เบี้ยขยัน == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalCommission) + `</td>`
          : "";
      html += this.table_head_model.วันหยุดพิเศษ == "1" ? `<td nowrap style="text-align:right;">` + groupSummary.extraHoliday + `</td>` : "";
      html += this.table_head_model.รายได้วันหยุดพิเศษ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.extraHolidayAmount) + `</td>` : "";
      html += this.table_head_model.รวมรายได้ == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.incomeBeforeExpenses) + `</td>` : "";
      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < leave_rate.length; s++) {
          if (groupSummaryLeave[s] != "" && groupSummaryLeave[s] != undefined) {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLeave[s]) + `</td>` : "";
          } else {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(0) + `</td>` : "";
          }
          if (groupSummaryLeaveInc[s] != "" && groupSummaryLeaveInc[s] != undefined) {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLeaveInc[s]) + `</td>` : "";
          } else {
            html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(0) + `</td>` : "";
          }
        }
      }
      html +=
        this.table_head_model.ชม_ลา_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.leave) + `</td>`
          : "";
      html +=
        this.table_head_model.หักเงินลา_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.leaveAmount) + `</td>`
          : "";
      html +=
        this.table_head_model.ลาไม่หักเงิน == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.leaveUncut) + `</td>`
          : "";

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < absent_rate.length; s++) {
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryAbsent[s]) + `</td>` : "";
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryAbsentInc[s]) + `</td>` : " ";
        }
      }

      html +=
        this.table_head_model.ชม_ขาด_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.absent) + `</td>`
          : "";
      html +=
        this.table_head_model.หักเงินขาด_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.absentAmount) + `</td>`
          : "";

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < late_rate.length; s++) {
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLate[s]) + `</td>` : "";
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryLateInc[s]) + `</td>` : "";
        }
      }

      html +=
        this.table_head_model.สาย_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalLate) + `</td>`
          : "";
      html +=
        this.table_head_model.หักเงินสาย_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.lateAmount) + `</td>`
          : "";

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var s = 0; s < ob_rate.length; s++) {
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryOb[s]) + `</td>` : "";
          html += this.table_head_model.เวลาเข้างาน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryObInc[s]) + `</td>` : "";
        }
      }

      html +=
        this.table_head_model.ออกก่อน_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalOB) + `</td>`
          : "";
      html +=
        this.table_head_model.หักออกก่อน_รวม == "1" && localStorage._is_timeattendance == 1
          ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.outBeforTimeAmount) + `</td>`
          : "";
      html += this.table_head_model.ประกันสังคม == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.insuranceAmount) + `</td>` : "";

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var u = 0; u < groupSummaryTaxlevel.length; u++) {
          // console.log(groupSummaryTaxlevel[u]);
          html += `   <td nowrap style="text-align:right;">` + ng.thousandSep(groupSummaryTaxlevel[u]) + `</td>`;
        }
      }

      html += this.table_head_model.ภาษี == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.salaryTax) + `</td>` : "";
      for (var s = 0; s < headVat.length; s++) {
        html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(groupSummaryVat[s]) + `</td>`;
      }
      html += this.table_head_model.ภาษี == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.vatAmount) + `</td>` : "";

      if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
        if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
          for (var s = 0; s < headExpenses.length; s++) {
            html += `<td nowrap class="subDetail" style="text-align:right;">` + ng.thousandSep(groupSummaryExpenses[s]) + `</td>`;
          }
        }
        html += `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.totalAddExpenses) + `</td>`;
      }

      html += this.table_head_model.รวมหัก == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.deductAmount) + `</td>` : "";
      html += this.table_head_model.คงเหลือเงิน == "1" ? `<td nowrap style="text-align:right;">` + ng.thousandSep(groupSummary.balanceAmount) + `</td>` : "";
      html += this.table_head_model.ประเภทการจ่ายเงิน == "1" ? `<td nowrap></td>` : "";
      html += this.table_head_model.เลขที่บัญชี == "1" ? `<td nowrap></td>` : "";
      html += "</tr>";

      return html;
    },
    renderDepartment(departmentName, ot_rate, absent_rate, leave_rate, ob_rate, late_rate, item, headReceive, headExpenses) {
      let ng = this;
      console.log(this.table_head_count);
      let headcount = this.table_head_count;
      if (this.table_head_model.เวลาเข้างาน == "1") {
        ot_rate.forEach((element) => {
          headcount += 2;
        });
        absent_rate.forEach((element) => {
          headcount += 2;
        });
        leave_rate.forEach((element) => {
          headcount += 2;
        });
        ob_rate.forEach((element) => {
          headcount += 2;
        });
        late_rate.forEach((element) => {
          headcount += 2;
        });
      }
      if (departmentName == "" || departmentName == undefined) {
        departmentName = "";
      }
      let html = "";
      let count = 15 + this.headReceive.length + this.headVat.length;
      html += `<tr style="">`;
      html += `<td nowrap colspan='${count}'>` + departmentName + `</td>`;
      html += `</tr>`;
      headcount = 0;
      return html;
    },
    getBranchName(code) {
      if (this.branch_items.filter((item) => item.code == code).length > 0) {
        return this.branch_items.filter((item) => item.code == code)[0].name;
      } else {
        return code;
      }
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    renderheader() {
      this.table_head_count = 0;
      let tableheader = "";
      let ng = this;
      tableheader += `<th nowrap ><input id="select_all" type="checkbox"></th>`;
      tableheader += `<th nowrap >#</th>`;
      tableheader += `<th nowrap >รหัส</th>`;
      tableheader += `<th nowrap >คำนำหน้า</th>`;
      tableheader += `<th nowrap >ชื่อ</th>`;
      tableheader += `<th nowrap >นามสกุล</th>`;
      if (this.table_head_model.ประเภท == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประเภท</th>`;
      }
      if (this.table_head_model.ตำแหน่ง == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ตำแหน่ง</th>`;
      }
      this.table_head_count += 1;
      tableheader += `<th nowrap>สาขา</th>`;
      if (this.table_head_model.วันทำงานเดือนนี้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center">วันทำงาน<br>เดือนนี้</th>`;
      }
      if (this.table_head_model.เงินเดือน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เงินเดือน</th>`;
      }
      if (this.table_head_model.ค่าฝีมือ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ค่าฝีมือ</th>`;
      }
      if (this.table_head_model.ค่าตำแหน่ง == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ค่าตำแหน่ง</th>`;
      }
      if (this.table_head_model.รวมเงินได้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมเงินได้</th>`;
      }
      if (this.table_head_model.วันละ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>วันละ</th>`;
      }
      if (this.table_head_model.ชั่วโมงละ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชั่วโมงละ</th>`;
      }

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.ot_rate.length; i++) {
          this.table_head_count += 1;
          tableheader += `<th nowrap >OT ` + this.ot_rate[i] + `</th> <th nowrap >เงินOT ` + this.ot_rate[i] + `</th>`;
        }
      }

      if (this.table_head_model.ชม_OT_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.OT รวม</th>`;
      }
      if (this.table_head_model.เงิน_OT_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เงิน OT รวม</th>`;
      }
      if (this.table_head_model.รวมรายรับอื่นๆ == "1") {
        this.table_head_count += 1;
        if (this.table_head_model.รายละเอียดรายรับ) {
          for (var i = 0; i < this.headReceive.length; i++) {
            this.table_head_count += 1;
            tableheader += `<th nowrap class="text-center subDetail" >` + this.headReceive[i].label + `</th>`;
          }
        }
        ///  tableheader += `<th nowrap>รวมรายรับอื่นๆ</th>`;
      }
      if (this.table_head_model.เบี้ยขยัน == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เบี้ยขยัน</th>`;
      }

      if (this.table_head_model.วันหยุดพิเศษ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>วันหยุดพิเศษ</th>`;
      }
      if (this.table_head_model.รายได้วันหยุดพิเศษ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รายได้วันหยุดพิเศษ</th>`;
      }
      if (this.table_head_model.รวมรายได้ == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมรายได้</th>`;
      }

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.leave_rate.length; i++) {
          this.table_head_count += 1;
          tableheader += `<th nowrap >ลา ` + this.leave_rate[i] + `</th> <th nowrap >หักเงินลา ` + this.leave_rate[i] + `</th>`;
        }
      }

      if (this.table_head_model.ชม_ลา_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.ลา รวม</th>`;
      }
      if (this.table_head_model.หักเงินลา_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินลา รวม</th>`;
      }
      if (this.table_head_model.ลาไม่หักเงิน == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ลาไม่หักเงิน (ชม.)</th>`;
      }

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.absent_rate.length; i++) {
          this.table_head_count += 1;
          tableheader += `<th nowrap >ขาด ` + this.absent_rate[i] + `</th> <th nowrap >หักเงินขาด ` + this.absent_rate[i] + `</th>`;
        }
      }
      if (this.table_head_model.ชม_ขาด_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ชม.ขาด รวม</th>`;
      }
      if (this.table_head_model.หักเงินขาด_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินขาด รวม</th>`;
      }

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.late_rate.length; i++) {
          this.table_head_count += 1;
          tableheader += `<th nowrap >สาย ` + this.late_rate[i] + `</th> <th nowrap >หักเงินสาย ` + this.late_rate[i] + `</th>`;
        }
      }
      if (this.table_head_model.สาย_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>สาย รวม</th>`;
      }

      if (this.table_head_model.หักเงินสาย_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักเงินสาย รวม</th>`;
      }

      if (this.table_head_model.เวลาเข้างาน == "1") {
        for (var i = 0; i < this.ob_rate.length; i++) {
          this.table_head_count += 1;
          tableheader += `<th nowrap >ออกก่อน ` + this.ob_rate[i] + `</th> <th nowrap >หักออกก่อน ` + this.ob_rate[i] + `</th>`;
        }
      }
      if (this.table_head_model.ออกก่อน_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ออกก่อน รวม</th>`;
      }
      if (this.table_head_model.หักออกก่อน_รวม == "1" && localStorage._is_timeattendance == 1) {
        this.table_head_count += 1;
        tableheader += `<th nowrap>หักออกก่อน รวม</th>`;
      }
      if (this.table_head_model.ประกันสังคม == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประกันสังคม</th>`;
      }
      if (this.table_head_model.ภาษี == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center subDetail" >ภาษีเงินเดือน</th>`;
      }
      for (var i = 0; i < this.headVat.length; i++) {
        this.table_head_count += 1;
        tableheader += `<th nowrap class="text-center subDetail" >ภาษี:` + this.headVat[i].name + `</th>`;
      }
      tableheader += this.table_head_model.ภาษี == "1" ? `<th nowrap>รวมภาษี</th>` : "";

      if (this.table_head_model.รวมรายจ่ายอื่นๆ == "1") {
        this.table_head_count += 1;

        if (this.table_head_model.รายละเอียดรายจ่าย == "1") {
          for (var i = 0; i < this.headExpenses.length; i++) {
            this.table_head_count += 1;
            tableheader += `<th nowrap class="text-center subDetail" >` + this.headExpenses[i] + `</th>`;
          }
        }
        tableheader += `<th nowrap>รวมรายจ่ายอื่นๆ</th>`;
      }

      if (this.table_head_model.รวมหัก == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>รวมหัก</th>`;
      }

      if (this.table_head_model.คงเหลือเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>คงเหลือเงิน</th>`;
      }

      if (this.table_head_model.ประเภทการจ่ายเงิน == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>ประเภทการจ่ายเงิน</th>`;
      }
      if (this.table_head_model.เลขที่บัญชี == "1") {
        this.table_head_count += 1;
        tableheader += `<th nowrap>เลขที่บัญชี</th>`;
      }

      this.showheadhtml = tableheader;
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },

    doToggleHeader(status) {
      this.table_head_model = {
        ประเภท: status,
        ตำแหน่ง: status,
        วันทำงานเดือนนี้: status,
        เงินเดือน: status,
        ค่าฝีมือ: status,
        ค่าตำแหน่ง: status,
        รวมเงินได้: status,
        วันละ: status,
        ชั่วโมงละ: status,
        ชม_OT_รวม: status,
        เงิน_OT_รวม: status,
        รายละเอียดรายรับ: status,
        รวมรายรับอื่นๆ: status,
        เบี้ยขยัน: status,
        วันหยุดพิเศษ: status,
        รายได้วันหยุดพิเศษ: status,
        รวมรายได้: status,
        ชม_ลา_รวม: status,
        หักเงินลา_รวม: status,
        ลาไม่หักเงิน: status,
        ชม_ขาด_รวม: status,
        หักเงินขาด_รวม: status,
        สาย_รวม: status,
        หักเงินสาย_รวม: status,
        ออกก่อน_รวม: status,
        หักออกก่อน_รวม: status,
        ประกันสังคม: status,
        ภาษี: status,
        รายละเอียดรายจ่าย: status,
        รวมรายจ่ายอื่นๆ: status,
        รวมหัก: status,
        คงเหลือเงิน: status,
        ประเภทการจ่ายเงิน: status,
        เลขที่บัญชี: status,
        เวลาเข้างาน: status,
      };
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = [];
          this.branch_items.push({ code: "", name: "ทั้งหมด" });
          this.branch_contributors.push({ code: "", name: "เลือกสาขา" });
          res.data.content.forEach((element) => {
            this.branch_items.push(element);
            this.branch_contributors.push(element);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then((res) => {
          this.delDialogStatus = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");
</style>
